<template>
  <div class="transfer-container">
    <div class="transfer-title">
      <label>轉移[{{ userDetail.name }}]的樓盤</label>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane
        v-if="isUsePropertyTransfer"
        label="樓盤轉移"
        name="first"
      >
        <el-form :inline="true">
          <div :class="{box_div:true,fixed_box:isFixed}" />
          <div :class="{divbox:true,fixed:isFixed}">
            <el-row>
              <el-form-item :label="'['+userDetail.name+']'+'角色類型：'">
                <!-- <span class="red redstar_one">*</span> -->
                <el-select
                  ref="typeSelect"
                  v-model="listQuery.searchAccountPropertyType"
                  class="wid_230"
                  placeholder="請選擇"
                  @change="typeChange('agentType')"
                  @visible-change="handleTypeChange"
                >
                  <el-option
                    v-for="item in buildingTypes"
                    :key="item.value"
                    label=" "
                    :value="item.value"
                  >
                    <div>
                      <span>{{ item.label }} (</span>
                      <span style="color:#0064FF;">
                        {{ item.value == 'owner' ? propertyAllNumber : agentAllNumber }}
                      </span>
                      <span>)</span>
                    </div>
                  </el-option>
                </el-select>
                <div
                  class="custom-selected"
                  @click="toggleTypeDropdown"
                >
                  <span>
                    <span style="max-width: 245px;display:inline-block;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;vertical-align: bottom; color: black;">{{ listQuery.searchAccountPropertyType == 'owner'? '放盤人（即個人放盤）' :'代理人（即個人代理盤）' }} </span>
                    <span style="display:inline-block;">(</span>
                    <span style="display:inline-block;color:#0064FF;">{{ listQuery.searchAccountPropertyType == 'owner' ? propertyAllNumber : agentAllNumber }}</span>
                    <span style="display:inline-block;">)</span>
                  </span>
                </div>
              </el-form-item>
              <!-- 樓盤轉移範圍 -->
              <el-form-item
                label="樓盤所屬組別："
                class="dep_mar"
                label-width="115px"
              >
                <!-- <span class="red redstar_one">*</span> -->
                <el-select
                  v-if="listQuery.searchAccountPropertyType == 'owner'"
                  ref="roleSelect"
                  v-model="departmentRolesAll"
                  multiple
                  placeholder="請選擇組別及角色"
                  class="w_400"
                  @change="multiSelChange"
                  @visible-change="handleVisibleChange"
                >
                  <el-checkbox-group v-model="departmentRolesAll">
                    <el-option
                      v-for="(item, index) in departmentOptions"
                      :key="index"
                      :label="item.departmentName + (item.accountDepartmentID ? '('+( listQuery.searchAccountPropertyType == 'agent' ? item.agentPropertyNumber : item.propertyNumber)+')' : '')"
                      :value="item.accountDepartmentID + ',' + item.roleID"
                    >
                      <div>
                        <el-checkbox
                          style="pointer-events: none"
                          :label="item.accountDepartmentID + ',' + item.roleID"
                        >
                          <slot
                            :node="item"
                            :data="item"
                          >
                            <span>{{ item.departmentName }}</span>
                            <span
                              v-show="item.accountDepartmentID"
                              style="color:#0064FF;"
                            >
                              {{ listQuery.searchAccountPropertyType == 'agent' ? '(' +item.agentPropertyNumber+')' : '(' +item.propertyNumber+')' }}
                            </span>
                          </slot>
                        </el-checkbox>
                      </div>
                    </el-option>
                  </el-checkbox-group>
                </el-select>
                <el-select
                  v-else
                  ref="roleSelect"
                  v-model="departmentRoles"
                  placeholder="請選擇組別及角色"
                  class="w_40001"
                  @change="departChange"
                  @visible-change="handleVisibleChange"
                >
                  <!-- :label="'所有組別' +'('+ allProNum +')'" -->
                  <el-option
                    v-show="listQuery.searchAccountPropertyType == 'owner' && departmentOptions.length > 1"
                    :value="0"
                    label=" "
                  >
                    <span>所有組別</span>
                    <!-- <span style="color:#0064FF;">
                                            {{ allProNum }}
                                        </span>
                                        <span>)</span> -->
                  </el-option>
                  <!-- :label="item.departmentName + '('+( listQuery.searchAccountPropertyType == 'agent' ? item.agentPropertyNumber : item.propertyNumber)+')'" -->
                  <el-option
                    v-for="(item, index) in departmentOptions"
                    :key="index"
                    label=" "
                    :value="item.accountDepartmentID + ',' + item.roleID"
                  >
                    <div>
                      <span>{{ item.departmentName }} (</span>
                      <span style="color:#0064FF;">
                        {{ listQuery.searchAccountPropertyType == 'agent' ? item.agentPropertyNumber : item.propertyNumber }}
                        <!-- {{ item.isLoginDepartmentManager ?(listQuery.searchAccountPropertyType == 'agent' ?  item.agentPropertyNumber : item.propertyNumber ) : 0}} -->
                      </span>
                      <span>)</span>
                    </div>
                  </el-option>
                </el-select>
                <div
                  v-show="listQuery.searchAccountPropertyType == 'agent'"
                  class="custom-selected"
                  @click="toggleDropdown"
                >
                  <!-- <span v-if="departmentRoles === 0 && listQuery.searchAccountPropertyType == 'owner' && departmentOptions.length > 1">
                                        <span style="max-width: 245px;display:inline-block;color: black;">所有組別 </span>
                                    </span> -->
                  <span>
                    <span style="max-width: 245px;display:inline-block;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;vertical-align: bottom; color: black;">{{ getSelectedDepartmentName(departmentRoles) }} </span>
                    <span style="display:inline-block;">(</span>
                    <span style="display:inline-block;color:#0064FF;">{{ getSelectedPropertyNumber(departmentRoles) }}</span>
                    <span style="display:inline-block;">)</span>
                  </span>
                </div>
              </el-form-item>

              <!-- <span class="red">組別角色與樓盤歸屬角色必須選擇才能完成轉移流程</span> -->
              <!-- true 打开了更多选项 -->
              <el-button
                v-if="isMoreChoose"
                class="more"
                type="warning"
                @click="isMoreChoose = !isMoreChoose"
              >
                收起更多選項
              </el-button>
              <el-button
                v-else
                class="more"
                type="warning"
                @click="openMore"
              >
                打開更多選項
              </el-button>
              <el-col v-if="listQuery.searchAccountPropertyType == 'owner'">
                <el-button
                  v-if="!showselected"
                  :class="{allbtn:true,disBtn:!total}"
                  type="primary"
                  @click="chooseAlltransfer('seled')"
                >
                  <!-- 選擇全部樓盤（共{{ listQuery.searchAccountPropertyType == 'agent' ?  agentAllNumber : propertyAllNumber}}個） -->
                  選擇全部樓盤（共{{ total }}個）
                </el-button>
                <el-button
                  v-else
                  class="allbtn"
                  type="primary"
                  @click="chooseAlltransfer('cancelSelAll')"
                >
                  取消選擇全部樓盤
                </el-button>
              </el-col>
            </el-row>
          </div>
          <el-row v-if="isMoreChoose">
            <el-col>
              <el-select
                v-model="rentalType"
                class="w100"
                no-data-text="暫無數據"
                placeholder="放盤類型"
              >
                <el-option
                  v-for="item in rentalList"
                  :key="item.dictionaryValue"
                  :label="item.dictionaryNameWithCulture"
                  :value="item.dictionaryValue"
                />
              </el-select>
              <el-input
                v-model="keyString"
                class="w315"
                placeholder="樓盤編號、物業編號、放盤人、屋苑"
                suffix-icon="el-icon-search"
              />
              <el-select
                v-model="categoryValue"
                class="w150"
                placeholder="樓盤類型"
              >
                <el-option
                  class="property-tags-cascader-none-li"
                  label="全部"
                  value="0"
                />

                <el-cascader-panel
                  :key="isResouceShow"
                  ref="cascader"
                  v-model="category"
                  :options="categoryList"
                  :show-all-levels="false"
                  class="property-tags-cascader-panelcheckbox"
                  collapse-tags
                  :props="{
                    multiple: true,
                    children: 'children',
                    value: 'dictionaryValue',
                    label: 'dictionaryNameWithCulture',
                    checkStrictly: false
                  }"
                  clearable
                  @change="categoryCascaderChange"
                />
              </el-select>
              <el-select
                v-model="regionCode"
                class="w150"
                placeholder="區域"
                @change="changeZone"
              >
                <el-option
                  v-for="(item, index) in regionList"
                  :key="index"
                  :label="item.gscopeNameWithCulture"
                  :value="item.gscopeCode"
                />
              </el-select>
              <el-select
                v-model="zoneCode"
                class="w150"
                placeholder="地區"
              >
                <el-option
                  v-for="(item, index) in zoneList"
                  :key="index"
                  :label="item.gscopeNameWithCulture"
                  :value="item.gscopeCode"
                />
              </el-select>
            </el-col>
            <el-col>
              <el-select
                v-model="unitFloor"
                class="w150"
                placeholder="樓層"
              >
                <el-option
                  v-for="item in unitFloorList"
                  :key="item.dictionaryValue"
                  :label="item.dictionaryNameWithCulture"
                  :value="item.dictionaryValue"
                />
              </el-select>
              <el-select
                v-model="showStatus"
                class="w150"
                placeholder="顯示狀態"
              >
                <el-option
                  label="全部"
                  :value="0"
                />
                <el-option
                  v-for="item in showStatusList"
                  :key="item.dictionaryValue"
                  :label="item.dictionaryNameWithCulture"
                  :value="item.dictionaryValue"
                />
              </el-select>
              <!-- ?????????? -->
              <el-select
                v-model="saleRentStatus"
                class="w150"
                placeholder="樓盤狀態"
              >
                <el-option
                  v-if="statusList.length"
                  label="全部"
                  :value="0"
                />
                <el-option
                  v-for="item in statusList"
                  :key="item.dictionaryValue"
                  :label="item.dictionaryNameWithCulture"
                  :value="item.dictionaryValue"
                />
              </el-select>
              <el-select
                v-model="isAdminOffLine"
                class="w150"
                placeholder="已被下架"
              >
                <el-option
                  v-for="item in isAdminOffList"
                  :key="item.dictionaryValue"
                  :label="item.dictionaryNameWithCulture"
                  :value="item.dictionaryValue"
                />
              </el-select>
              <el-select
                v-model="topType"
                class="w150"
                placeholder="放盤方式"
              >
                <el-option
                  label="全部"
                  :value="0"
                />
                <el-option
                  v-for="item in topOptions"
                  :key="item.dictionaryValue"
                  :label="item.dictionaryNameWithCulture"
                  :value="item.dictionaryValue"
                />
              </el-select>
              <el-select
                v-model="propertyLabelValueList"
                class="w160"
                style="width: 176px"
                multiple
                collapse-tags
                placeholder="功能"
              >
                <el-option
                  v-for="item in propertyLabel"
                  :key="item.dictionaryValue"
                  :label="item.dictionaryNameWithCulture"
                  :value="item.dictionaryValue"
                />
              </el-select>
              <!-- <span class="time">到期時間：</span>
                            <el-date-picker class="w150 mr4" format="yyyy/MM/dd" value-format="timestamp" v-model="expireStartTime" :picker-options="expireTimeOption2" type="date" placeholder="選擇日期"></el-date-picker>-
                            <el-date-picker class="w150" format="yyyy/MM/dd" value-format="timestamp" v-model="expireEndTime" :picker-options="expireTimeOption" type="date" placeholder="選擇日期"></el-date-picker>
                            <el-button @click="typeChange" type="danger">搜尋</el-button>
                            <el-button @click="resetSearch" type="info">重置</el-button> -->
            </el-col>
            <el-col>
              <span class="area-span">租價範圍：</span>
              <el-select
                v-if="rentPriceCode !== 0 && !minRentPrice && !maxRentPrice"
                v-model="rentPriceCode"
                class="w160"
                placeholder="請選擇租價範圍"
              >
                <el-option
                  label="自訂範圍"
                  :value="0"
                />
                <el-option
                  v-for="item in rentPriceList"
                  :key="item.dictionaryValue"
                  :label="item.dictionaryNameWithCulture"
                  :value="item.dictionaryValue"
                />
              </el-select>
              <div
                v-else
                class="input-model w245"
              >
                <el-input
                  v-model="minRentPrice"
                  class="w90"
                  placeholder="請輸入價格"
                  @blur="numerInput('minRentPrice')"
                />
                <span class="pm">-</span>
                <el-input
                  v-model="maxRentPrice"
                  class="w90"
                  placeholder="請輸入價格"
                  @blur="numerInput('maxRentPrice')"
                />
                <span class="pm">元</span>
              </div>
              <span class="area-span">售價範圍：</span>
              <el-select
                v-if="salePriceCode !== 0 && !minSalePrice && !maxSalePrice"
                v-model="salePriceCode"
                class="w160"
                placeholder="請選擇售價範圍"
              >
                <el-option
                  label="自訂範圍"
                  :value="0"
                />
                <el-option
                  v-for="item in salePriceList"
                  :key="item.dictionaryValue"
                  :label="item.dictionaryNameWithCulture"
                  :value="item.dictionaryValue"
                />
              </el-select>
              <div
                v-else
                class="input-model w245"
              >
                <el-input
                  v-model="minSalePrice"
                  class="w90"
                  placeholder="請輸入價格"
                  @blur="numerInput('minSalePrice')"
                />
                <span class="pm">-</span>
                <el-input
                  v-model="maxSalePrice"
                  class="w90"
                  placeholder="請輸入價格"
                  @blur="numerInput('maxSalePrice')"
                />
                <span class="pm">萬</span>
              </div>
              <span class="area-span">建築面積：</span>
              <el-select
                v-model="buildingAreaCode"
                class="w160"
                placeholder="請選擇建築面積"
              >
                <el-option
                  label="全部"
                  :value="0"
                />
                <el-option
                  v-for="item in areaList"
                  :key="item.dictionaryValue"
                  :label="item.dictionaryNameWithCulture"
                  :value="item.dictionaryValue"
                />
              </el-select>
              <span class="area-span">實用面積：</span>
              <el-select
                v-model="saleableAreaCode"
                class="w160"
                placeholder="請選擇實用面積"
              >
                <el-option
                  label="全部"
                  :value="0"
                />
                <el-option
                  v-for="item in areaList"
                  :key="item.dictionaryValue"
                  :label="item.dictionaryNameWithCulture"
                  :value="item.dictionaryValue"
                />
              </el-select>
            </el-col>
            <el-col>
              <span class="time">放盤時間：</span>
              <el-date-picker
                v-model="publicTimeStartTime"
                class="w150 mr4"
                format="yyyy/MM/dd"
                value-format="timestamp"
                :picker-options="publicTimeOption2"
                type="date"
                placeholder="選擇日期"
              />-
              <el-date-picker
                v-model="publicTimeEndTime"
                class="w150"
                format="yyyy/MM/dd"
                value-format="timestamp"
                :picker-options="publicTimeOption"
                type="date"
                placeholder="選擇日期"
              />
              <span class="time">到期時間：</span>
              <el-date-picker
                v-model="expireStartTime"
                class="w150 mr4"
                format="yyyy/MM/dd"
                value-format="timestamp"
                :picker-options="expireTimeOption2"
                type="date"
                placeholder="選擇日期"
              />-
              <el-date-picker
                v-model="expireEndTime"
                class="w150"
                format="yyyy/MM/dd"
                value-format="timestamp"
                :picker-options="expireTimeOption"
                type="date"
                placeholder="選擇日期"
              />
              <el-button
                type="danger"
                @click="typeChange"
              >
                搜尋
              </el-button>
              <el-button
                type="info"
                @click="resetSearch"
              >
                重置
              </el-button>
            </el-col>
          </el-row>
        </el-form>
        <div class="container table-container">
          <div
            ref="topScroll"
            class="top-scroll"
            @scroll="handleScrollTop"
          >
            <div
              class="top-scroll-content"
              :style="tablewidth"
            />
          </div>
          <el-table
            ref="multipleTable"
            :key="tableKey"
            v-loading="listLoading"
            empty-text="暫無數據"
            :data="list"
            fit
            :header-cell-style="{ background: 'rgba(80,181,255,0.15)' }"
            @selection-change="sortChange"
          >
            <el-table-column
              type="selection"
              fixed="left"
              width="55"
              :selectable="showisDisProperty"
            />
            <el-table-column
              label="放盤人"
              min-width="150px"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span>{{ scope.row.accountName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="原有組別"
              min-width="110px"
              prop="departmentNameWithCulture"
              show-overflow-tooltip
            />
            <el-table-column
              label="原有代理人"
              min-width="180px"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span
                  v-for="(item ,index) in scope.row.agentNames"
                  :key="index"
                >
                  <span>{{ item }}</span>
                  <span v-show="index != scope.row.agentNames.length-1 && scope.row.agentNames.length !=1">,<br></span>
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="樓盤編號"
              min-width="110px"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span
                  class="blu_txt"
                  @click="enterDetails(scope.row.rentalType, scope.row.propertyID)"
                >{{ scope.row.propertyID ? scope.row.propertyID : '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="物業編號"
              min-width="110px"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span>{{ scope.row.propertyNo ? scope.row.propertyNo : '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="放盤類型"
              min-width="110px"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span>{{ scope.row.rentalType == 1 ? '放售' : '放租' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="放盤方式"
              min-width="110px"
              prop="topTypeWithCulture"
              show-overflow-tooltip
            />
            <el-table-column
              label="圖片"
              width="100"
            >
              <template slot-scope="scope">
                <!-- 图片 -->
                <img
                  class="img-cover"
                  :src="pub.imgResize(scope.row.imagePath, 'user')"
                  onerror="errorImg(this,'property')"
                  alt
                >
              </template>
            </el-table-column>
            <el-table-column
              label="標題"
              min-width="110px"
              prop="titleWithCulture"
              show-overflow-tooltip
            />
            <el-table-column
              label="區域"
              min-width="110px"
              prop="regionNameWithCulture"
              show-overflow-tooltip
            />
            <el-table-column
              label="地區"
              min-width="110px"
              prop="gscopeNameWithCulture"
              show-overflow-tooltip
            />
            <el-table-column
              label="屋苑"
              min-width="110px"
              prop="estateNameWithCulture"
              show-overflow-tooltip
            />
            <el-table-column
              label="座數及單位"
              min-width="110px"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span>{{ scope.row.buildingName || scope.row.roomNo ? scope.row.buildingName + (scope.row.roomNo ? scope.row.roomNo:''): '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="樓層"
              min-width="110px"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span>{{ scope.row.unitFloorWithCulture ? scope.row.unitFloorWithCulture : '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="分類"
              min-width="110px"
              prop="propertyCategoryWithCulture"
              show-overflow-tooltip
            />
            <el-table-column
              label="價格(萬)"
              min-width="110px"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="!scope.row.isReducePaidSalePrice && scope.row.isReduceUnPaidSalePrice">{{ scope.row.unPaidSalePrice | priceUnit }}</span>
                <span v-else-if="scope.row.salePrice">{{ scope.row.salePrice | priceUnit }}{{ !scope.row.isReducePaidSalePrice && !scope.row.isReduceUnPaidSalePrice && scope.row.subCategory && (scope.row.subCategory[6] || scope.row.subCategory[7]) ? (scope.row.paidSalePrice ? '(已補)' : '(未補)') : '' }}</span>
                <span v-else>-</span>
              </template>
              <!-- <template slot-scope="scope">
                                <span>{{ Number(scope.row.salePrice / 10000) }}</span>
                            </template> -->
            </el-table-column>
            <el-table-column
              label="租價(元)"
              min-width="110px"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span>{{ scope.row.rentPrice ? scope.row.rentPrice : '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="面積"
              min-width="150px"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <p>實用面積: {{ scope.row.saleableArea ? scope.row.saleableArea : '-' }}</p>
                <p>建築面積: {{ scope.row.buildingArea ? scope.row.buildingArea : '-' }}</p>
              </template>
            </el-table-column>
            <el-table-column
              label="顯示狀態"
              min-width="110px"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span>{{ scope.row.isHide ? '隱藏' : '顯示' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="放盤狀態"
              min-width="110px"
              prop="propertyStatusWithCulture"
              show-overflow-tooltip
            />
            <el-table-column
              label="樓盤詳情"
              width="200"
            >
              <template slot-scope="scope">
                <p>更新時間:{{ scope.row.updateTime | getTime }}</p>
                <p>放盤時間:{{ scope.row.publicTime | getTime }}</p>
              </template>
            </el-table-column>
            <el-table-column
              label="到期時間"
              min-width="110px"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span
                  v-if="scope.row.expireTime > 0"
                  :class="{ red: expiredDate >= scope.row.expireTime }"
                >{{ scope.row.expireTime | getTime }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            class="bottom-right"
            :total="total"
            :page.sync="listQuery.pageIndex"
            :limit.sync="listQuery.pageCount"
            @pagination="getList"
          />
        </div>

        <el-row
          v-if="listQuery.searchAccountPropertyType == 'agent'"
          class="bottom-container"
        >
          <el-col :span="12">
            <span class="red">*</span>
            <span>修改代理人&nbsp;&nbsp;&nbsp;[{{ userDetail.name }}]為&nbsp;&nbsp;</span>
            <el-select
              v-model="newInformation"
              filterable
              placeholder="請選擇員工"
              class="w160"
              @change="handleChange"
            >
              <el-option
                v-for="(item, index) in userOptions"
                :key="index"
                :label="item.name + '（' + dePartmentNm + '）'"
                :value="item.accountID + ',' + item.status"
              />
            </el-select>
          </el-col>
          <el-col
            :span="12"
            class="btn"
          >
            <el-button
              type="primary"
              @click="propertyTransfer"
            >
              儲存
            </el-button>
            <el-button @click="getBack">
              返回
            </el-button>
          </el-col>
        </el-row>
        <!-- 跨组转移 -->
        <div
          v-if="listQuery.searchAccountPropertyType == 'owner' && (isDisProperty || showOwnerErr)"
          class="red"
        >
          你沒有權限操作以上樓盤
          <el-button
            class="back lef_10"
            @click="getBack"
          >
            返回
          </el-button>
        </div>
        <div
          v-if="listQuery.searchAccountPropertyType == 'owner' && !isDisProperty && !showOwnerErr"
          class="depTran_box"
        >
          <div class="owner_tit">
            <div>重要提醒：</div>
            <div>此操作會更新所有選中樓盤的放盤人及代理人，</div>
            <div>原有的放盤人及代理人不會保留。</div>
          </div>
          <div class="depleft_box">
            <el-form
              ref="transForm"
              :model="transForm"
              :rules="transRules"
              label-width="105px"
              @submit.native.prevent
            >
              <el-row>
                <el-form-item
                  prop="receiveTransID"
                  label="轉移組別"
                  class="transfer_dep"
                >
                  <!--楼盘转移无需对同组别禁用 popper-class="dep_cascader" -->
                  <el-cascader
                    ref="cascaders"
                    v-model="transForm.receiveTransID"
                    placeholder="請選擇樓盤轉向的新組別"
                    :options="transferDepOptions"
                    :show-all-levels="false"
                    clearable
                    popper-class="dep_cascader"
                    :props="{
                      checkStrictly: true,
                      children: 'childNode',
                      value: 'departmentID',
                      label: 'departmentName',
                      disabled: 'disabled'
                    }"
                    @change="depChange"
                  >
                    <template #default="{ data }">
                      <!-- <template #default="{ node, data }"> -->
                      <el-tooltip
                        v-if="data.disabled"
                        content="無法選擇組別，請關聯分行"
                        placement="top"
                        :open-delay="500"
                      >
                        <span class="cascader-item">{{ data.departmentName }}</span>
                      </el-tooltip>
                      <span
                        v-else
                        class="cascader-item"
                      >{{ data.departmentName }}</span>
                    </template>
                    <!-- <template slot-scope="{ node, data }">
                                    <el-tooltip content="" placement="top" :open-delay="500">
                                        <template #content>
                                            <div class="titleContent">{{ data.departmentName }}</div>
                                        </template>
                                        <span class="cascader-item" :title="data.departmentName">{{ data.departmentName }}</span>
                                    </el-tooltip>
                                </template> -->
                  </el-cascader>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item
                  label="選擇新放盤人"
                  prop="ownerTransId"
                  class="fangpan_one"
                >
                  <el-select
                    v-model="transForm.ownerTransId"
                    class="w_300"
                    filterable
                    placeholder="請選擇員工"
                    clearable
                    @change="selectTransChange"
                  >
                    <el-option
                      v-for="(item, index) in ownerLists"
                      :key="index"
                      :label="item.name + '(' + item.departmentName + ')'"
                      :value="item.accountID"
                    />
                  </el-select>
                </el-form-item>
              </el-row>
              <el-row v-show="isShowAgentRadio">
                <div class="agentRadio">
                  <el-checkbox
                    v-model="changeAgent"
                    @change="clearAgent"
                  >
                    代理人不變
                  </el-checkbox>
                </div>
              </el-row>
              <!-- <el-row> -->
              <div class="owner_tips">
                新代理人（1–3 位）將套用至全部選中樓盤。
              </div>
              <!-- </el-row> -->
              <el-row>
                <el-form-item
                  label="選擇新代理人1（必填）"
                  prop="selectedAgents"
                >
                  <el-select
                    v-model="transForm.selectedAgents[0]"
                    class="w_300"
                    filterable
                    placeholder="請選擇員工"
                    clearable
                    :disabled="changeAgent"
                    @change="selectTransChange"
                  >
                    <el-option
                      v-for="(item, index) in agentLists"
                      :key="index"
                      :label="item.name + '(' + item.departmentName + ')'"
                      :value="item.accountID"
                      :disabled="transForm.selectedAgents.includes(item.accountID)"
                    />
                  </el-select>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item
                  label="選擇新代理人2（選填）"
                  class="agentTrans_more"
                >
                  <el-select
                    v-model="transForm.selectedAgents[1]"
                    class="w_300"
                    filterable
                    placeholder="請選擇員工"
                    clearable
                    :disabled="!transForm.selectedAgents[0] || changeAgent"
                    @change="selectTransChange"
                  >
                    <el-option
                      v-for="(item, index) in agentLists"
                      :key="index"
                      :label="item.name + '(' + item.departmentName + ')'"
                      :value="item.accountID"
                      :disabled="transForm.selectedAgents.includes(item.accountID)"
                    />
                  </el-select>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item
                  label="選擇新代理人3（選填）"
                  class="agentTrans_more"
                >
                  <el-select
                    v-model="transForm.selectedAgents[2]"
                    class="w_300"
                    filterable
                    placeholder="請選擇員工"
                    clearable
                    :disabled="!transForm.selectedAgents[0] || changeAgent"
                    @change="selectTransChange"
                  >
                    <el-option
                      v-for="(item, index) in agentLists"
                      :key="index"
                      :label="item.name + '(' + item.departmentName + ')'"
                      :value="item.accountID"
                      :disabled="transForm.selectedAgents.includes(item.accountID)"
                    />
                  </el-select>
                </el-form-item>
              </el-row>
              <div class="btn_box">
                <el-button
                  type="primary"
                  class="pribut"
                  @click="crossTransfer('transForm')"
                >
                  確認
                </el-button>
                <el-button
                  class="back"
                  @click="getBack"
                >
                  返回
                </el-button>
              </div>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane
        v-if="isUsePersonnelTransfer"
        label="人員調動"
        name="second"
      >
        <el-form
          ref="staffForm"
          :inline="true"
          label-width="68px"
          :rules="staffRules"
          :model="mobilizationQuery"
        >
          <el-row>
            <el-form-item label="組別：">
              <el-select
                v-model="departmentRole"
                placeholder="請選擇組別角色"
                @change="selectChange"
              >
                <el-option
                  v-for="(item, index) in oldDepartments"
                  :key="index"
                  :label="item.departmentName + '---' + item.roleName"
                  :value="item.accountDepartmentID + ',' + item.departmentName + ',' + item.roleID + ',' + item.roleName"
                />
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="轉移至：">
              <el-cascader
                ref="cascader"
                v-model="mobilizationQuery.newDepartmentID"
                filterable
                placeholder="請選擇組別"
                :options="organizationOptions"
                expand-trigger="hover"
                :props="{ children: 'childNode', value: 'departmentID', label: 'departmentName', checkStrictly: true, emitPath: false }"
                :show-all-levels="false"
                @change="newDepartmentChange"
              />
            </el-form-item>
            <el-form-item label="角色：">
              <el-select
                v-model="mobilizationQuery.newRoleName"
                placeholder="請選擇角色"
                @change="newRoleChange"
              >
                <el-option
                  v-for="item in roleOptions"
                  :key="item.roleID"
                  :label="item.roleName"
                  :value="item.roleID + ',' + item.roleName"
                />
              </el-select>
            </el-form-item>
          </el-row>
          <el-row v-if="mobilizationQuery.newRoleID && mobilizationQuery.newRoleID != '4' && !userDetail.email">
            <el-form-item
              label="電郵："
              class="w600"
              prop="email"
            >
              <el-input
                v-model.trim="mobilizationQuery.email"
                maxlength="60"
                required
                @blur="changeMail"
              />
              <span
                v-show="repeatEmail"
                class="span_errtxt"
              >{{ mobilizationQuery.email }}<br>該電郵地址已註冊，請使用其他電郵地址</span>
              <!-- <div class="err_txt" v-if="isMailEmpty">請輸入電郵</div> -->
            </el-form-item>
          </el-row>
          <el-button
            type="primary"
            @click="staffTransfer"
          >
            儲存
          </el-button>
          <el-button
            class="back"
            @click="getBack"
          >
            返回
          </el-button>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      :visible.sync="showTransferDialog"
      width="268px"
      class="tandialog"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="ce">
        <p>正在轉移{{ startCount }}-{{ endCount }}個樓盤</p>
        <i class="el-icon-loading" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination';
import { mapGetters } from 'vuex';
export default {
    name: 'StaffingTransfer',
    components: { Pagination },
    data() {
        let agentValue = (rule, value, callback) => {
            if (!this.transForm.selectedAgents.length && !this.transForm.selectedAgents[0] && !this.changeAgent) {
                callback(new Error('請選擇代理人'))
            } else {
                callback();
            }
        };
        let email = (rule, value, callback) => {
            if ( !this.mobilizationQuery.email || this.mobilizationQuery.email === '') {
                return callback(new Error('請輸入電郵'));
            }
                const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                if (!emailRegex.test(this.mobilizationQuery.email)) {
                    callback(new Error('請輸入正確的郵箱地址'));
                } else {
                    callback(); // 验证通过
                }

        };
        return {
            scrollValue: 0,
            /**操作栏是否置顶 */
            isFixed: false,
            startCount:'',
            endCount:'',
            showTransferDialog:false,
            copyAgents:[],
            selectedId:[],
            showselected:false,//true ui显示 为取消全选按钮,但 当前为全部选中状态;
            selLength:0,
            agentAllNumber:'',
            propertyAllNumber:'',
            repeatEmail:false,
            staffRules:{
                email: [
                    { required: true, validator: email , trigger: ['blur']},
                ]
            },
            tablewidth:{
                width:0
            },
            tableDom:null,
            showOwnerErr:false,
            rolePro:false,//楼盘角色权限判断
            isDisProperty:false,//true 权限不够，false则可以操作
            transRules:{
                receiveTransID: [{ required: true,  message: '請選擇樓盤轉向的新組別',trigger: 'change' }],
                ownerTransId: [{ required: true,  message: '請選擇放盤人',trigger: 'change' }],
                selectedAgents: [{ required: true, validator: agentValue, trigger: 'change' }],
            },
            isMailEmpty:false,
            transferDepOptions:[],
            transForm:{
                ownerTransId:'',
                selectedAgents:[],
                receiveTransID:[],
            },
            ownerLists:[],
            agentLists:[],
            changeAgent:false,
            isShowAgentRadio:false,

            isMoreChoose:false,
            rentalType: '',
            keyString: '',
            categoryValue: '',
            category: '',
            zoneCode:'',
            regionCode:'',
            unitFloor: '',
            isAdminOffLine:'',
            topType: '',
            topOptions: [],
            propertyLabelValueList: [],
            propertyLabel: [],
            saleRentStatus: '',
            publicTimeStartTime: '',
            publicTimeEndTime: '',
            expireStartTime: '',
            expireEndTime:'',
            rentalList: [],
            isResouceShow: 1,
            copyPropertyTags: [],
            categoryValueEnd: [],
            categoryIf: [], //已经选择的楼盘类型
            categoryList:[],
            regionList:[],//动态根据区域来走regioncode
            zoneList:[],
            zoneListCopy:[],
            unitFloorList: [],
            showStatus: '',
            showStatusList: [
                { dictionaryValue: 1, dictionaryNameWithCulture: '顯示' },
                { dictionaryValue: 2, dictionaryNameWithCulture: '隱藏' }
            ],
            statusList: [],
            isAdminOffList: [],
            SaleStatusList: [],
            RentStatusList: [],
            rentPriceCode: '',
            minRentPrice: '',
            maxRentPrice: '',
            salePriceCode: '',
            minSalePrice: '',
            maxSalePrice: '',
            buildingAreaCode: '',
            saleableAreaCode: '',
            salePriceList: [],
            rentPriceList: [],
            areaList:[],
            expireTimeOption: {
                disabledDate: this.expireTimeOption1
            },
            publicTimeOption: {
                disabledDate: this.publicTimeOption1
            },
            expireTimeOption2: {
                disabledDate: this.expireTimeOption3
            },
            publicTimeOption2: {
                disabledDate: this.publicTimeOption3
            },

            isUsePropertyTransfer:true,
            isUsePersonnelTransfer:true,
            isDepartmentTransfer:true,//是否组别转移
            userDetail: {},
            accountID: null,
            departmentRoles: 0,
            departmentRolesAll:[],
            includeAll:false,
            // dePartmentNm: '',
            departmentOptions: [],
            userOptions: [],
            total: 0,
            // isdepID:true,
            buildingTypes: [
                { value: 'owner', label: '放盤人（即個人放盤）' },
                { value: 'agent', label: '代理人（即個人代理盤）' }
            ],
            listQuery: {
                accountID: null,
                departmentID: null,
                departmentIDList:[],
                pageIndex: 1,
                pageCount: 10,
                searchAccountPropertyType: 'owner',
                RefStaffMananger: true
            },
            transferQuery: {
                propertyIDs: [],
                oldAccountID: null,
                newAccountID: null,
                departmentID: null
            },
            mobilizationQuery: {
                accountName: '',
                email:'',
                accountID: null,
                oldDepartmentName: '',
                oldDepartmentID: null,
                newDepartmentName: '',
                newDepartmentID: null,
                oldRoleName: '',
                oldRoleID: null,
                newRoleName: '',
                newRoleID: null
            },
            department: false,
            role: false,
            newDepartment: '',
            newRole: '',
            departmentRole: null,
            oldDepartments: [],
            roleOptions: [],
            // roleOptionsAll:[],
            newInformation: '',
            multipleSelection: '',
            departmentID: null,
            organizationOptions: [],
            activeName: '',
            tableKey: 0,
            list: [],
            listLoading: false,
            importance: '',
            allProNum:'',
            departmentIDList:[],//所有组别获取表格数据传递字段
            isDropdownOpen: false,
            isTypeOpen:false,
            agentName:'',
            expiredDate: parseInt((new Date().getTime() + 5 * 24 * 60 * 60 * 1000) / 1000)
        };
    },
    watch:{
        /**判断滚动距离 */
        scrollValue(val) {
            if (this.isMoreChoose) {
                if (val >= 700) {
                    this.isFixed = true;
                    this.isMoreChoose = false
                } else {
                    this.isFixed = false;
                }
            } else {
                if (val >= 280) {
                    this.isFixed = true;
                } else {
                    this.isFixed = false;
                }
            }

        },
            /**租售价修改监控 */
        rentPriceCode(val) {
            this.watchRentPrice(val);
        },
        minRentPrice(val) {
            this.watchRentPrice(val);
        },
        maxRentPrice(val) {
            this.watchRentPrice(val);
        },
        salePriceCode(val) {
            this.watchSalePrice(val);
        },
        minSalePrice(val) {
            this.watchSalePrice(val);
        },
        maxSalePrice(val) {
            this.watchSalePrice(val);
        },
        /**租售關聯 */
        rentalType(val) {
            if (val == 1) {
                this.statusList = this.SaleStatusList;
            } else if (val == 2) {
                this.statusList = this.RentStatusList;
            } else {
                this.statusList = [];
            }
        }
    },
    computed: {
        ...mapGetters(['userInfo'])
    },
    async created() {
        this.userDetail = JSON.parse(localStorage.getItem('userDetail'));
        this.accountID = this.userDetail.accountID;
        // this.departmentOptions = this.userDetail.roleList;
        this.dePartmentNm = this.userDetail.roleList[0].departmentName;
        this.transferQuery.oldAccountID = this.userDetail.accountID;
        this.mobilizationQuery.accountID = this.userDetail.accountID;
        this.mobilizationQuery.accountName = this.userDetail.name;
        await this.pub.getDictionary().then(res => {
            this.rentalList = res.RentalType.children;
            this.isAdminOffList = res.isAdminOffLine.children;
            this.topOptions = res.TopOptions.children;
            this.salePriceList = res.SalePrice.children;
            this.rentPriceList = res.RentPrice.children;
            this.areaList = res.Area.children;
            this.propertyLabel = res.PropertyLabel.children;
            this.categoryList = res.PropertyCategory.children;
            this.unitFloorList = res.UnitFloor.children;
            this.SaleStatusList = res.SalePropertyStatus.children;
            this.RentStatusList = res.RentPropertyStatus.children;
            /**放盘状态判断 获取放盘状态列表 */
            if (this.rentalType == 1) {
                this.statusList = this.SaleStatusList;
            } else if (this.rentalType == 2) {
                this.statusList = this.RentStatusList;
            } else {
                this.statusList = [];
            }
        });
        let resgscope = await this.axios.get(this.pub.getApi().GetGscope);
        if (resgscope.data.code === 0 && resgscope.data.result) {
            //获取区域值
            this.regionList = resgscope.data.result;
            resgscope.data.result.forEach(item => {
                item.children.forEach(i => {
                    this.zoneListCopy.push(i);
                    this.zoneList.push(i)
                });
            });
        }
        await this.resetNumber()

        this.getOrganizationOptions();
        this.getUserRoles();
        this.getUserInfoByAccountID();
        // 页面提示value.split错误 数据未加载导致（后续会处理）
        if(this.$route.query.type){
            this.listQuery.searchAccountPropertyType = this.$route.query.type
            if(this.$route.query.type == 'agent' && !this.$route.query.depID){
                this.typeChange('agentType')
            }
        }
        // 员工列表跳转进入
        if(this.$route.query.type == 'agent' && this.$route.query.depID){
            this.departmentRoles = ''
            this.departmentRoles = this.$route.query.depID + ',' +  this.$route.query.roleID
            this.listQuery.departmentID = this.$route.query.depID
        }
        if(this.$route.query.type == 'owner' && this.$route.query.depID){
            this.departmentRolesAll = []
            this.departmentRolesAll.push( this.$route.query.depID + ',' +  this.$route.query.roleID)
            this.listQuery.departmentIDList.push(parseInt(this.departmentRolesAll[0]))
        }
        this.listQuery.pageCount = this.pub.getPageSize(this.$store.state.userInfo.accountID, 'statraPageCount') || 10;
        this.getList()
        this.getCompanyCofig()
        this.getDepartmentsTree();

    },
    mounted(){
        document.querySelector('.el-main').addEventListener('scroll', this.handleScroll);

    },
    methods: {
        openMore(){
            document.querySelector('.el-main').scrollTop = 0
            this.isMoreChoose = !this.isMoreChoose
        },
        handleScroll() {
            this.scrollValue = document.querySelector('.el-main').scrollTop;
        },
        changeScroll(val) {
            setTimeout(() => {
                this.$nextTick(() => {
                    this.scrollValue = val;
                    document.querySelector('.el-main').scrollTop = val;
                });
            }, 1000);
        },
        chooseAlltransfer(type){
            // 勾选状态的数据表格
            this.selLength = this.total
            if(type == 'cancelSelAll'){
                this.$refs.multipleTable.clearSelection();
                this.selLength = 0
                this.showselected = false
            }else{
                this.showselected = true
                this.list.forEach((row) => {
                if (this.showisDisProperty(row)) {
                    this.$refs.multipleTable.toggleRowSelection(row, true);
                    }
                });
            }
        },
        numerInput(type){
            this[type] = this[type].replace(/[^0-9]/g, '');
        },
        watchRentPrice(val) {
            if (!val) {return;}
            this.rentalType = '2';
            this.salePriceCode = '';
            this.minSalePrice = '';
            this.maxSalePrice = '';
        },
        watchSalePrice(val) {
            if (!val) {return;}
            this.rentalType = '1';
            this.rentPriceCode = '';
            this.minRentPrice = '';
            this.maxRentPrice = '';
        },
        changeMail(){
            if(this.mobilizationQuery.email != ''){
                this.isMailEmpty = false
            }
        },
        showisDisProperty(){
            if(this.isDisProperty){return false}
            return true;
        },
        enterDetails(type, id) {
            let url = `${this.pub.config.pcUrl}${type === 1 ? 'buy' : 'rent'}-property-${id}/`;
            window.open(url);
        },
        toggleTypeDropdown() {
            // 切换状态
            if (this.$refs.typeSelect) {
                if (this.isTypeOpen) {
                this.$refs.typeSelect.toggleMenu();  // 打开
                } else {
                this.$refs.typeSelect.close();  // 关闭
                }
            }
            this.isTypeOpen = !this.isTypeOpen;
        },
        toggleDropdown() {
            // 切换状态
            if (this.$refs.roleSelect) {
                if (this.isDropdownOpen) {
                this.$refs.roleSelect.toggleMenu();  // 打开
                } else {
                this.$refs.roleSelect.close();  // 关闭
                }
            }
            this.isDropdownOpen = !this.isDropdownOpen;
        },
        handleTypeChange(isVisible){
            this.isTypeOpen = !isVisible;
        },
        handleVisibleChange(isVisible) {
            this.isDropdownOpen = !isVisible;
        },
        getSelectedDepartmentName(value){
            if(value){
                const [departmentID, roleID] = value.split(',');
                const department = this.departmentOptions.find(item => item.accountDepartmentID === parseInt(departmentID));
                return department ? department.departmentName : '';
            }
        },
        getSelectedPropertyNumber(value){
            if(value){
                const [departmentID, roleID] = value.split(',');
                const department = this.departmentOptions.find(item => item.accountDepartmentID === parseInt(departmentID));
                return department ? (this.listQuery.searchAccountPropertyType === 'agent' ? department.agentPropertyNumber : department.propertyNumber) : '';
            }
            // return department ? (department.isLoginDepartmentManager ? (this.listQuery.searchAccountPropertyType === 'agent' ? department.agentPropertyNumber : department.propertyNumber) :0) : '';
        },
        clearAgent(){
            this.transForm.selectedAgents = []
        },
        resetNumber(){
            return new Promise((resolve, reject) => {
                // this.axios
                //     .post(this.pub.getApi().SearchDistinctOrganizationUserInfo, {
                //         pageIndex: 1,
                //         PageCount: 100,
                //         searchName:this.userDetail.name
                //     })
                this.axios
                .get(this.pub.getApi().GetUserInfoByAccountID, {
                    params: {
                        accountID: this.userDetail.accountID
                    }
                }).then(res => {
                        if (res.data.code === 0) {
                            // isLoginDepartmentManager为false时，表当前组别无转移楼盘货登录用户与所选用户权限冲突
                            // 此时该组别显示在下拉列表，只是其后的楼盘数量手动置为0
                            // this.departmentOptions =  res.data.result.data[0].roleList.filter(item => item.isLoginDepartmentManager === true);
                            this.departmentOptions =  res.data.result.roleList.filter(item => item.isLoginDepartmentManager === true);
                            // 指存在一个组别时，默认选中第一个
                            if(this.departmentOptions.length == 1){
                                if(this.listQuery.searchAccountPropertyType === 'agent'){
                                    this.departmentRoles = this.departmentOptions[0].accountDepartmentID + ',' + this.departmentOptions[0].roleID
                                }else{
                                    this.departmentRolesAll.push(this.departmentOptions[0].accountDepartmentID + ',' + this.departmentOptions[0].roleID)
                                }
                            }else if(this.listQuery.searchAccountPropertyType === 'owner'){
                                this.departmentOptions.unshift({accountDepartmentID:0,roleID:0,departmentName:'所有組別',agentPropertyNumber:0,propertyNumber:0})
                            }
                            this.agentAllNumber = res.data.result.agentPropertyNumber
                            this.propertyAllNumber = res.data.result.propertyNumber
                            this.allProNum = this.departmentOptions.reduce((acc, item) => {
                                if (this.listQuery.searchAccountPropertyType === 'owner') {
                                    return acc + item.propertyNumber
                                    // return item.isLoginDepartmentManager ? acc + item.propertyNumber : acc + 0;
                                } else if (this.listQuery.searchAccountPropertyType === 'agent') {
                                    return acc + item.agentPropertyNumber
                                    // return item.isLoginDepartmentManager ? acc + item.agentPropertyNumber : acc +0;
                                }
                                return acc;
                            }, 0);
                        }
                        resolve()

                    });
            })
        },
        crossTransfer(formName){
            if (this.multipleSelection.length === 0 && !this.showselected) {
                if (document.getElementsByClassName('el-message').length === 0) {
                    this.$message({
                        type: 'warning',
                        message: '請至少選擇一個樓盤去轉移',
                        showClose: true
                    });
                }
                return
            }
            if(!this.listQuery.searchAccountPropertyType){
                this.$message({
                    type: 'warning',
                    message: '請選擇放盤人類型？',
                    showClose: true
                });
            }
            this.copyAgents = []
            // 按照列表的顺序 按顺序返回给接口
            // 1. 创建映射：将 a 中每个 age 与索引关联
            if(!this.changeAgent){
                const orderMap = new Map(this.agentLists.map((item, index) => [item.accountID, index]));
                // 2. 根据映射的索引重新排序 b
                this.transForm.selectedAgents.sort((aId, bId) => orderMap.get(aId) - orderMap.get(bId))
                this.copyAgents = this.transForm.selectedAgents.filter(id => id != "" && id != null)
            }
            this.$refs[formName].validate(async (valid,errobj) => {
                if(valid){
                    //  true代表目前为选中状态
                    if(this.showselected){
                        let pageIndexTotal = 1;
                        const totalPages = Math.ceil(this.total / 100);
                        let goOnTran = true;
                        // 用一个递归函数按顺序处理每一页
                        // eslint-disable-next-line no-shadow
                        const processPage = async (pageIndexTotal) => {
                            if(pageIndexTotal > totalPages || !goOnTran){
                                // 全部完成
                                this.showselected = false;
                                this.selLength = 0
                                this.$refs.transForm.resetFields();
                                this.getList();
                                this.resetNumber()
                                if(pageIndexTotal > totalPages){
                                    this.$confirm(`完成轉移全部${this.total}個樓盤！`, '提示', {
                                        confirmButtonText: '確認',
                                        type: 'success',
                                        showCancelButton: false,
                                        iconClass: 'el-icon-success',
                                    }).then({

                                    })
                                }
                                return;
                            }
                            this.listQuery.accountID = this.accountID;
                            const data = this.getSearchValue()
                            data.pageIndex = 1
                            data.pageCount = 100
                            try {
                                const res = await this.axios.post(this.pub.getApi().SearchPropertyList, data);
                                if (res.data.code === 0 && res.data.result) {
                                    this.transferQuery.propertyIDs = res.data.result.data.map(item => item.propertyID);
                                    if (pageIndexTotal === 1) {
                                        this.startCount = '1';
                                        this.endCount = pageIndexTotal < totalPages ? pageIndexTotal*100 : this.total
                                        this.showTransferDialog = true
                                        // 第一批直接转移
                                        setTimeout(async () => {
                                            try {
                                                    await this.transferProcess();
                                                    this.showTransferDialog = false;
                                                    processPage(pageIndexTotal + 1);
                                                } catch (error) {
                                                    this.$confirm(`由於網絡問题，導致轉移失敗<br/>請再次嘗試轉移操作。`, '提示', {
                                                        confirmButtonText: '確認',
                                                        type: 'warning',
                                                        iconClass:'el-icon-error',
                                                        showCancelButton: false,
                                                        dangerouslyUseHTMLString: true,
                                                    }).then(async () => {
                                                        this.$refs.transForm.resetFields();
                                                        this.getList();
                                                        this.resetNumber()
                                                        return
                                                    })
                                                } finally {
                                                    this.showTransferDialog = false;
                                                }
                                            // await this.transferProcess();
                                            // processPage(pageIndexTotal + 1);
                                            // this.showTransferDialog = false
                                        }, 2000);

                                    } else {
                                        let count = pageIndexTotal < totalPages ? pageIndexTotal*100 : this.total
                                        // 第二批及之后需要确认
                                        this.$confirm(`繼續轉移${((pageIndexTotal-1)*100+1)} - ${count} 個樓盤？`, '提示', {
                                            confirmButtonText: '確認',
                                            cancelButtonText: '取消',
                                            closeOnClickModal:false,
                                            type: 'warning'
                                        }).then(async () => {
                                            document.querySelector('.el-main').scrollTop = 0
                                            this.startCount = (pageIndexTotal-1)*100+1;
                                            this.endCount = pageIndexTotal < totalPages ? pageIndexTotal*100 : this.total
                                            this.showTransferDialog = true
                                            setTimeout(async () => {
                                                try {
                                                    await this.transferProcess();
                                                    processPage(pageIndexTotal + 1);
                                                } catch (error) {
                                                    this.$confirm(`<div style="font-weight:700;color:#444444;font-size:16px;">已成功轉移${(pageIndexTotal-1)*100}個樓盤</div><div color:#444444;font-size:16px;">由於網絡問题，部分樓盤未能轉移，導致轉移失敗，</div><div color:#444444;font-size:16px;">請再次嘗試轉移操作。</div>`, '提示', {
                                                        confirmButtonText: '確認',
                                                        type: 'warning',
                                                        showCancelButton: false,
                                                        dangerouslyUseHTMLString: true,
                                                    }).then(async () => {
                                                        this.$refs.transForm.resetFields();
                                                        this.getList();
                                                        this.resetNumber()
                                                        document.querySelector('.el-main').scrollTop = 0
                                                        return
                                                    })
                                                } finally {
                                                    this.showTransferDialog = false;
                                                }
                                            }, 2000);
                                        }).catch(() => {
                                            // 用户取消，则不再继续后续分页
                                            this.showselected = false;
                                            this.selLength = 0
                                            goOnTran = false
                                            this.$refs.transForm.resetFields();
                                            this.getList();
                                            this.resetNumber()
                                            document.querySelector('.el-main').scrollTop = 0
                                            this.$confirm(`完成轉移全部${(pageIndexTotal-1)*100}個樓盤！`, '提示', {
                                                confirmButtonText: '確認',
                                                type: 'warning',
                                                showCancelButton: false,
                                                iconClass:'el-icon-success',
                                            }).then(async () => {
                                                document.querySelector('.el-main').scrollTop = 0
                                            })
                                            // this.$message({
                                            //     type: 'info',
                                            //     message: `已取消第 ${((pageIndexTotal-1)*100+1)} - ${count} 条數據的转移`
                                            // });

                                        });
                                    }
                                }
                            } catch (e) {
                                goOnTran = false
                                this.showTransferDialog = false
                                this.showselected = false;
                                this.selLength = 0
                                if(pageIndexTotal == 1){
                                    this.$confirm(`<div style="font-weight:700;color:#444444;font-size:16px;">由於網絡問题，導致轉移失敗</div><div color:#444444;font-size:16px;">請再次嘗試轉移操作。</div>`, '提示', {
                                        confirmButtonText: '確認',
                                        type: 'warning',
                                        iconClass:'el-icon-error',
                                        showCancelButton: false,
                                        dangerouslyUseHTMLString: true,
                                    }).then(async () => {
                                        this.$refs.transForm.resetFields();
                                        this.getList();
                                        this.resetNumber()
                                        return
                                    })
                                }

                            }
                        };

                        processPage(pageIndexTotal);
                    }else{
                        this.transferProcess()
                    }
                }else{
                    // this.error('樓盤資料不完整，請根據提示補充資料');
                    return false;
                }
            })
        },
        transferProcess(){
            return new Promise(async (resolve, reject) => {
                this.selectedId = Array.isArray(this.transForm.receiveTransID)
                    ? this.transForm.receiveTransID[this.transForm.receiveTransID.length - 1]
                    : this.transForm.receiveTransID[0];

                let data = {
                    propertyIDs: this.transferQuery.propertyIDs,
                    AccountID: this.transForm.ownerTransId,
                    AgentAccountIDs: this.copyAgents,
                    DepartmentID: this.selectedId,
                };

                try {
                    if (this.changeAgent) {
                        this.transferQuery.newAccountID = this.transForm.ownerTransId;
                        await this.propertyTransfer();
                        if(!this.showselected){
                            this.$refs.transForm.resetFields();
                        }
                        resolve();
                    } else {
                        const res = await this.axios.post(this.pub.getApi().CrossDepartmentTrans, data, { timeout: 10000 } )
                        if (res.data.code === 0 && res.data.result) {
                            this.$message({
                                type: 'success',
                                message: '操作成功!',
                                showClose: true
                            });
                            this.$nextTick(() => {
                                document.querySelector('.el-main').scrollTop = 0;
                            });
                            if(!this.showselected){
                                this.$refs.transForm.resetFields();
                                this.getList();
                                this.resetNumber();
                            }
                            resolve();
                        } else {
                            if(!this.showselected){
                                this.$message({
                                    type: 'error',
                                    message: '操作失败!',
                                    showClose: true
                                });
                            }
                            reject(new Error('操作失败'));
                        }
                    }
                } catch (e) {
                    // 捕获 axios 网络错误，传递到 processPage 的 catch
                    console.error("transferProcess error:", e);
                    reject(e);
                }
            });
        },
        selectTransChange(){
            //
            console.log("选择放盘人和代理人")
        },
        // 跨组转移相关数据
        resetTransferDep(type){
            this.ownerLists = []
            this.agentLists = []
            this.transForm.ownerTransId = ''
            this.transForm.selectedAgents = []
            if(type !== 'dep'){
                this.transForm.receiveTransID = []
            }
        },
        depChange(){
            // 选中了最后一层数据后，点击即关闭该下拉框
            const cascaderNodes = this.$refs.cascaders.getCheckedNodes();
            if (cascaderNodes.length > 0 && cascaderNodes[0].children.length === 0) {
                this.$refs.cascaders.dropDownVisible = false;
            }

            // if(this.departmentRoles){
            if(this.departmentRolesAll.length == 1){
                let arry = [];
                // arry = this.departmentRoles.split(',');
                arry = this.departmentRolesAll[0].split(',');
                //选择了和选中员工同样的组别，展示代理人不变
                if(this.transForm.receiveTransID[this.transForm.receiveTransID.length - 1] == arry[0]){
                    this.isShowAgentRadio = true
                }else{
                    this.isShowAgentRadio = false
                    this.changeAgent = false
                }
            }
            // 当清除了多层级选项后，再次打开需要展示一级弹框，而不是同上次选中的层级
            if (this.$refs.cascaders && !this.transForm.receiveTransID.length) {
                this.$refs.cascaders.$refs.panel.activePath = []; // 清除高亮
                this.$refs.cascaders.$refs.panel.syncActivePath();
            }
            this.resetTransferDep('dep')
            this.getUserOptions('transferDep');
        },
        async getDepartmentsTree () {
            this.transferDepOptions = []
            let res = await this.axios.get(
                this.pub.getApi().GetDepartmentsTreeByParentID,
                {
                    params: {
                        departmentID: this.userInfo.departmentID
                    }
                }
            );
            let { code, message, result } = res.data;
            let treeDisData =[]
            if (code === 0) {
                treeDisData.push(result)
                this.transferDepOptions = this.addDisabledFlag(treeDisData);
                // this.transferDepOptions.push(result);
            }
        },
        addDisabledFlag(options){
            return options.map(node => {
                node.disabled = !node.storeID; //storeID 不存在即禁用
                if (node.childNode) {
                    node.childNode = this.addDisabledFlag(node.childNode); // Recurse for children
                }
                return node;
            });
        },
        // 板块改变，地区更改
        changeZone(){
            this.regionList.forEach(item => {
                if (item.gscopeCode === this.regionCode) {
                    this.zoneList = item.children;
                }
            });
            this.zoneCode= ''
        },
        getSearchValue(){
            const data = {};
            if (typeof this.keyString == 'number') {
                this.keyString = String(this.keyString);
            }
            // if(this.listQuery.departmentID) data.departmentID = this.departmentRoles == 0 ? '' : this.listQuery.departmentID;
            if(this.listQuery.departmentID) {data.departmentID = this.listQuery.departmentID;}
            if(this.listQuery.pageIndex) {data.pageIndex = this.listQuery.pageIndex;}
            if(this.listQuery.pageCount) {data.pageCount = this.listQuery.pageCount;}
            if(this.listQuery.searchAccountPropertyType) {data.searchAccountPropertyType = this.listQuery.searchAccountPropertyType;}
            if(this.listQuery.RefStaffMananger) {data.RefStaffMananger = this.listQuery.RefStaffMananger;}
            if(this.listQuery.departmentIDList) {data.departmentIDList = this.listQuery.departmentIDList;}
            if(this.accountID) {data.accountID = this.accountID;}
            if (this.keyString) {data.keyString = this.keyString.trim();}
            if (this.zoneCode) {data.zoneCode = this.zoneCode;}
            if (this.showStatus) {data.isHide = this.showStatus - 1;}
            if (this.saleRentStatus) {data.propertyStatus = this.saleRentStatus;}
            if (this.isAdminOffLine) {data.isAdminOffLine = this.isAdminOffLine == 0 ? false : true;}
            if (this.topType) {data.topType = Number(this.topType);}
            if (this.propertyLabelValueList && this.propertyLabelValueList.length) {data.propertyLabelValueList = this.propertyLabelValueList;}
            if (this.regionCode) {data.regionCode = this.regionCode;}
            if (this.rentalType) {data.rentalType = Number(this.rentalType);}
            if (this.unitFloor) {data.unitFloor = this.unitFloor;}
            if (this.expireStartTime) {data.expireStartTime = parseInt(this.expireStartTime / 1000);}
            if (this.publicTimeStartTime) {data.publicTimeStartTime = parseInt(this.publicTimeStartTime / 1000);}
            /**放盘时间 */
            if (this.publicTimeEndTime) {
                if (this.$route.params.due) {data.publicTimeEndTime = parseInt(this.publicTimeEndTime / 1000);}
                else {data.publicTimeEndTime = parseInt(this.publicTimeEndTime / 1000 + 24 * 60 * 60);}
            }
            /**租售价格*/
            if (this.rentPriceCode) {
                data.minRentPrice = this.rentPriceCode.split('-')[0];
                data.maxRentPrice = this.rentPriceCode.split('-')[1];
            }
            if (this.salePriceCode) {
                data.minSalePrice = this.salePriceCode.split('-')[0];
                data.maxSalePrice = this.salePriceCode.split('-')[1];
            }
            if (this.minRentPrice) {data.minRentPrice = this.minRentPrice;}
            if (this.maxRentPrice) {data.maxRentPrice = this.maxRentPrice;}
            if (this.minSalePrice) {data.minSalePrice = this.minSalePrice * 10000;}
            if (this.maxSalePrice) {data.maxSalePrice = this.maxSalePrice * 10000;}
            if (this.buildingAreaCode) {
                data.minBuildingArea = this.buildingAreaCode.split('-')[0];
                data.maxBuildingArea = this.buildingAreaCode.split('-')[1];
            }
            if (this.saleableAreaCode) {
                data.minSaleableArea = this.saleableAreaCode.split('-')[0];
                data.maxSaleableArea = this.saleableAreaCode.split('-')[1];
            }
            /**过期时间 */
            if (this.expireEndTime) {
               data.expireEndTime = parseInt(this.expireEndTime / 1000 + 24 * 60 * 60);
            }
            this.categoryList.forEach(item => {
                if (item.itemName == this.categoryIf[0]) {
                    if (item.children != null) {
                        // 二级筛选
                        if (item.children.length != this.categoryIf.length - 1 && this.categoryIf.length > 1) {data.SubCategory = this.categoryIf.slice(1);}
                        // 一级分类
                        if (item.children.length == this.categoryIf.length - 1) {data.category = this.categoryIf[0];}
                    } else {
                        data.category = this.categoryIf[0];
                    }
                }
            });
            return data;
        },
        resetSearch(){
            this.rentalType =  '';
            this.keyString =  '';
            this.category =  '';
            this.categoryIf = '';
            this.categoryValue = '';
            this.zoneCode = ''
            this.showStatus = '';
            this.saleRentStatus = '';
            this.isAdminOffLine = '';
            this.topType = '';
            this.propertyLabelValueList = [];
            this.rentPriceCode = '';
            this.salePriceCode = '';
            this.minRentPrice = '';
            this.maxRentPrice = '';
            this.minSalePrice = '';
            this.maxSalePrice = '';
            this.buildingAreaCode = '';
            this.saleableAreaCode = '';
            this.unitFloor = '';
            this.regionCode = ''
            this.expireStartTime = '';
            this.publicTimeStartTime = '';
            this.publicTimeEndTime = '';
            this.expireEndTime = '';
            this.listQuery.pageIndex = 1;
            this.zoneList = [];
            for (let index = 0; index < this.zoneListCopy.length; index++) {
                this.zoneList.push(this.zoneListCopy[index])
            }
            this.getSearchValue()
            this.typeChange();
        },
        expireTimeOption3(time) {
            if (this.expireEndTime) {
                return time.getTime() > this.expireEndTime;
            }
                return false;

        },
        expireTimeOption1(time) {
            if (this.expireStartTime) {
                return time.getTime() < this.expireStartTime;
            }
                return false;

        },
        categoryCascaderChange(val) {
            let that = this;
            let ConversData = [];
            // 是否与上次的类型相同
            let changeFlag = false;
            let changeItem = null;
            if (this.categoryValueEnd.length == 0) {
                this.category = val;
            } else {
                // 与原数组比对
                this.category.forEach(item => {
                    if (item[0] !== this.categoryValueEnd[0][0]) {
                        // 一级标签不同
                        changeFlag = true;
                        changeItem = item;
                        ConversData.push(item);
                    } else if ((!item[2] && this.categoryValueEnd[0][2]) || (item[2] && !this.categoryValueEnd[0][2])) {
                        changeFlag = true;
                        changeItem = item;
                        // console.log('二级标签不同');
                    }
                });
            }
            if (changeFlag) {
                this.category = [];
                this.category = ConversData;
            }
            function flatten(arr) {
                while (arr.some(item => Array.isArray(item))) {
                    //如果当前数组中还有数组，则展开
                    arr = [].concat(...arr);
                }
                return arr;
            }
            this.categoryValueEnd = this.category;
            let categoryValueEnd2 = flatten(this.category);
            this.categoryIf = [...new Set(categoryValueEnd2)];
            if (!this.category || !this.category.length) {
                this.categoryValue = '';
                return;
            }
            this.categoryValue = `樓盤類型(已選${this.category.length}個標籤)`;
        },
        getCompanyCofig() {
            this.axios.get(this.pub.getApi().GetCompanyCofig).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    this.isUsePropertyTransfer = res.data.result.isUsePropertyTransfer
                    this.isUsePersonnelTransfer = res.data.result.isUsePersonnelTransfer
                    this.isDepartmentTransfer = res.data.result.isDepartmentTransfer
                    this.activeName = this.isUsePropertyTransfer ? 'first':'second'
                    this.activeName = this.$route.query.activeName || 'first';
                }
            });
        },
        // 更改为上方选择 楼盘转移组织selectChange
        departChange(val) {
            if (val != 0) {
                let arry = [];
                if(val){
                    arry = val.split(',');
                }else{
                    return
                }
                this.newInformation = '';
                this.listQuery.pageIndex = 1;
                this.listQuery.departmentID = parseInt(arry[0]);
                // 樓盤所屬組別 存在不允许转移的楼盘组别时，其isLoginDepartmentManager为false,此时的楼盘数要置0，不进行列表数据的访问
                // this.isdepID = this.departmentOptions.some(item => {
                //     return item.accountDepartmentID === parseInt(arry[0]) && item.isLoginDepartmentManager === true
                // });
                // 当同一个组别，同为分行管理员 禁用楼盘转移，且展示红色文字提示
                // if(this.listQuery.searchAccountPropertyType === 'owner' && this.departmentRole !== 0){
                //     this.rolePro = false; //false 表角色没权限，true表有权限
                //     this.checkRolediction(parseInt(arry[0]),parseInt(arry[1]));
                //     if(!this.rolePro){
                //         this.isDisProperty = true
                //     }else {
                //         //  true展示红字
                //         this.isDisProperty = false
                //         this.showOwnerErr = false
                //     }
                //     this.showisDisProperty()

                //     // if(this.userInfo.departmentID == parseInt(arry[0]) && this.userInfo.roleID ==  parseInt(arry[1]) ){
                //     //     this.isDisProperty = true
                //     // }else{
                //     //     this.isDisProperty = false
                //     // }
                // }else{
                    this.isDisProperty = false
                    this.showOwnerErr = false
                    this.showisDisProperty()
                // }
                // 判断组织权限
                // this.department = false;
                // this.role = false;
                // this.checkJurisdiction(parseInt(arry[0]), parseInt(arry[1]), this.organizationOptions);
                // if (this.department === false || this.role === false) {
                //     console.log("---1----")

                //     if (document.getElementsByClassName('el-message').length === 0) {
                //         this.$message({
                //             type: 'error',
                //             message: '該組別和角色級別較高，無權操作，請重新選擇！',
                //             showClose: true
                //         });
                //     }
                // }
            }else if(this.isDisProperty){
                // 页面先选择禁用的某组别，后又选择了所有组别后，页面的禁用需解除
                this.isDisProperty = false
                this.showOwnerErr = false
                this.showisDisProperty()
            }
            this.isShowAgentRadio = false
            this.changeAgent = false
            this.resetTransferDep()
            if ( this.listQuery.searchAccountPropertyType == 'agent') {
                // if(val == 10){
                    // this.getDepartmentsTree();
                // }else{
                    this.getUserOptions();
                // }
            }
            this.getList();

            // if(this.listQuery.searchAccountPropertyType === 'agent'){
            //     this.changeAgentName()
            // }
            //  else {
            //     if(val == 10){
                // this.transferDepOptions = [];
                // }else{
                //     this.userOptions = [];
                // }

            // }
        },
        // 仅有owner使用
        multiSelChange(){
            this.showselected = false //取消全选
            this.selLength = 0
            const allSelectedKey = '0,0';
            const bFormatted = this.departmentOptions.map(item => `${item.accountDepartmentID},${item.roleID}`);
            if (this.departmentRolesAll.includes(allSelectedKey)) {
                // 共5个选项，选了3个，第四个选中'全选'，要保证全部选中 走最下判断
                if(this.departmentRolesAll.length == this.departmentOptions.length-1 && this.departmentRolesAll[this.departmentRolesAll.length-1] != '0,0'){
                    // 选中了全选后，取消了其余选项，全选需要被取消
                    this.includeAll = false
                    const index = this.departmentRolesAll.indexOf('0,0');
                    this.departmentRolesAll.splice(index, 1);
                }else{
                    // 勾选了全选
                    this.includeAll = true
                    this.departmentRolesAll.length = 0;
                    this.departmentRolesAll.push(...new Set(bFormatted)); // 去重后放入
                }
            }else if(this.includeAll) {
                // 取消了全选
                this.departmentRolesAll.length = 0;
                this.departmentRolesAll.push(...new Set(bFormatted.filter(val => this.departmentRolesAll.includes(val))));
                this.includeAll = false
            }else if(this.departmentRolesAll.length == this.departmentOptions.length-1){
                // 选中了除全选外的所有其余选项，默认勾中全选
                this.includeAll = true

                if(this.departmentOptions.length != 1){
                    this.departmentRolesAll.unshift('0,0')
                }
            }
            // 输入框可取消显示所有组别
            if (this.departmentRolesAll.includes(allSelectedKey)) {
                this.$nextTick(() => {
                    const domNodeList = document.querySelectorAll('.w_400 .el-select__tags .el-tag .el-select__tags-text')
                    if (domNodeList.length > 1) {
                        const domNode = document.querySelector('.w_400 .el-select__tags .el-tag:first-child .el-select__tags-text')
                        if(domNode.innerText.includes('所有組別')){
                            document.querySelector('.w_400 .el-select__tags .el-tag:first-child').style.display = 'none'
                        }
                    }
                })
            }
            // 多选和全选
            if(this.departmentRolesAll && (this.departmentRolesAll.length > 1 || !this.departmentRolesAll.length)){
                this.departmentRoles = null
                if(this.departmentRolesAll.length > 1){
                    this.listQuery.departmentIDList = this.departmentRolesAll
                        .filter(item => item !== '0,0')
                        .map(item => parseInt(item.split(',')[0]));
                }else{
                    this.listQuery.departmentIDList = []
                }
                if(this.isDisProperty){
                    // 页面先选择禁用的某组别，后又选择了所有组别后，页面的禁用需解除
                    this.isDisProperty = false
                    this.showOwnerErr = false
                    this.showisDisProperty()
                }
            }else if(this.departmentRolesAll && this.departmentRolesAll.length == 1){
                // 单选
                this.listQuery.departmentIDList = []
                let val = this.departmentRolesAll[0]
                let arry = [];
                if(val){
                    arry = val.split(',');
                }else{
                    return
                }
                this.newInformation = '';
                this.listQuery.pageIndex = 1;
                this.listQuery.departmentIDList = this.departmentRolesAll
                .filter(item => item !== '0,0')
                .map(item => parseInt(item.split(',')[0]));
                // 当同一个组别，同为分行管理员 禁用楼盘转移，且展示红色文字提示
                if(this.listQuery.searchAccountPropertyType === 'owner'){
                    this.rolePro = false; //false 表角色没权限，true表有权限
                    this.checkRolediction(parseInt(arry[0]),parseInt(arry[1]));
                    if(!this.rolePro){
                        this.isDisProperty = true
                    }else {
                        //  true展示红字
                        this.isDisProperty = false
                        this.showOwnerErr = false
                    }
                    this.showisDisProperty()
                }
                // else{
                //     this.isDisProperty = false
                //     this.showOwnerErr = false
                //     this.showisDisProperty()
                // }
            }
            this.isShowAgentRadio = false
            this.changeAgent = false
            this.resetTransferDep()
            // if ( this.listQuery.searchAccountPropertyType == 'agent') {
            //     this.getUserOptions();
            // }

            this.getList();
        },
        // 樓盤類型change
        typeChange(type) {
            this.listQuery.pageIndex = 1;
            // 更换放盘人代理人选择时候清空选中项
            if(type == 'agentType'){
                this.departmentRoles = ''
                this.departmentRolesAll = []
                if(this.listQuery.searchAccountPropertyType === 'agent'){
                    this.listQuery.departmentIDList = []
                    this.listQuery.departmentID = ''
                    this.newInformation = '';
                    this.userOptions = [];
                    // this.departmentOptions.shift()
                    // 默认选中有数值第一个，若都为0，默认选中第一个
                    let allAgesZero = this.departmentOptions.every(item => item.agentPropertyNumber === 0);
                    this.departmentOptions = this.departmentOptions.filter(item => item.departmentName != '所有組別');
                    if (allAgesZero) {
                        this.departmentRoles =  this.departmentOptions[0].accountDepartmentID + ','+ this.departmentOptions[0].roleID; // Assign the first element if all ages are 0
                    } else {
                        // b = filteredA.filter(item => item.age !== 0); // Assign elements with age not equal to 0
                        let firstNonZeroAgeItem = this.departmentOptions.find(item => item.agentPropertyNumber !== 0);
                        this.departmentRoles = firstNonZeroAgeItem.accountDepartmentID + ','+ firstNonZeroAgeItem.roleID
                    }
                    // 当为禁用的组别，切换为代理人无需禁用处理
                    this.isDisProperty = false
                    this.showOwnerErr = false
                    this.showisDisProperty()
                }else{
                    this.listQuery.departmentIDList = []
                    this.listQuery.departmentID = ''
                    if(this.departmentOptions.length == 1){
                        this.departmentRolesAll.push(this.departmentOptions[0].accountDepartmentID + ','+ this.departmentOptions[0].roleID)
                        // this.departmentRoles =  this.departmentOptions[0].accountDepartmentID + ','+ this.departmentOptions[0].roleID;
                    }else{
                        let includeAll = this.departmentOptions.some(item => item.departmentName === '所有組別');
                        if(!includeAll){
                            this.departmentOptions.unshift({accountDepartmentID:0,roleID:0,departmentName:'所有組別',agentPropertyNumber:0,propertyNumber:0})
                        }
                        // 默认选中所有组别
                        // this.departmentRoles = 0
                        this.departmentRolesAll.push('0,0')
                        this.multiSelChange()
                    }
                }
                this.transForm.ownerTransId = ''
                this.transForm.selectedAgents = []
                this.transForm.receiveTransID = []
                this.isShowAgentRadio = false
                this.changeAgent = false
                this.allProNum = this.departmentOptions.reduce((acc, item) => {
                        if (this.listQuery.searchAccountPropertyType === 'owner') {
                            return acc + item.propertyNumber
                            // return item.isLoginDepartmentManager ? acc + item.propertyNumber : 0;
                        } else if (this.listQuery.searchAccountPropertyType === 'agent') {
                            return acc + item.agentPropertyNumber
                            // return item.isLoginDepartmentManager ? acc + item.agentPropertyNumber : 0;
                        }
                        return acc;
                    }, 0);
            }
            if (this.listQuery.searchAccountPropertyType =='agent') {
                // if(this.departmentRoles == 10){
                    // this.getDepartmentsTree();
                // }else{
                    this.getUserOptions();
                // }
            }else{
                this.getList();
                this.showselected = false
                this.selLength = 0
            }

            // if(this.departmentRoles){
            //     let arry = [];
            //     arry = this.departmentRoles.split(',');
            //     this.department = false;
            //     this.role = false;
            //     this.checkJurisdiction(parseInt(arry[0]), parseInt(arry[1]), this.organizationOptions);
            //     if (this.department === false || this.role === false) {
            //         console.log("---2----")
            //         if (document.getElementsByClassName('el-message').length === 0) {
            //             this.$message({
            //                 type: 'error',
            //                 message: '該組別和角色級別較高，無權操作，請重新選擇！',
            //                 showClose: true
            //             });
            //         }
            //     }
            // }

        },
        // 查询员工下拉
        getUserOptions(type) {
            let selectedId = ''
            // 没有选所有组别
            let departmentRolesCopy = ''
            let departmentIDListCopy = []
            // 多选
            if(this.departmentRolesAll.length != 1 && this.departmentRolesAll.includes('0,0') == false  ){
                departmentIDListCopy = this.departmentRolesAll
                    .filter(item => item !== '0,0')
                    .map(item => parseInt(item.split(',')[0]));

            }else if(this.departmentRolesAll.includes('0,0') == true){
                // 全选
                departmentRolesCopy = 0
            }else if(this.departmentRolesAll.length == 1){
                // 单选
                departmentRolesCopy = this.departmentRolesAll[0]
            }
            // if(this.departmentRoles != 0){
            //     var arry = [];
            //     arry = this.departmentRoles.split(',');
            // }

            selectedId = Array.isArray(this.transForm.receiveTransID) ? this.transForm.receiveTransID[this.transForm.receiveTransID.length - 1] : this.transForm.receiveTransID[0]
            if (selectedId && (this.listQuery.searchAccountPropertyType === 'owner' || type == 'transferDep' )) {
                // 個人盤
                this.axios
                    .post(this.pub.getApi().SearchMarketParticipantsUser, {
                        departmentID: selectedId
                    })
                    .then(res => {
                        if (res.data.code === 0 && res.data.result) {
                            // this.listQuery.departmentID = this.departmentRoles != 0 ? parseInt(arry[0]) : '';
                            // 全选
                            if(this.departmentRolesAll.includes('0,0') == true){
                                this.listQuery.departmentID = ''
                                this.listQuery.departmentIDList  = []
                            }else if(this.departmentRolesAll.length > 1){
                                this.listQuery.departmentIDList =[]
                                 this.listQuery.departmentIDList = this.departmentRolesAll
                                .filter(item => item !== '0,0')
                                .map(item => parseInt(item.split(',')[0]));
                            }else if(this.departmentRolesAll.length == 1 ){
                                // this.listQuery.departmentIDList =  parseInt(this.departmentRolesAll[0])
                                this.listQuery.departmentIDList =[]
                                this.listQuery.departmentIDList.push(parseInt(this.departmentRolesAll[0]))
                            }
                            this.listQuery.accountID = this.accountID;
                            if(type != 'transferDep'){
                                this.getList();
                            }
                            let me = this;

                            let users = res.data.result;
                            me.ownerLists = [];
                            // for (var i in me.departmentOptions) {
                            //     if (me.departmentOptions[i].accountDepartmentID === parseInt(arry[0])) {
                            //         me.dePartmentNm = me.departmentOptions[i].departmentName;
                            //     }
                            // }
                            // me.userOptions = [];
                            // 当放盘人转移，跨组时保留自己，选择本组刨除自己。
                            // if(this.isShowAgentRadio){
                            //     for (var j in users) {
                            //         if (users[j].accountID !== me.accountID && users[j].status === 'Normal') {
                            //             me.ownerLists.push(users[j]);
                            //         }
                            //     }
                            // }else{
                                for (let j in users) {
                                    if (users[j].status === 'Normal') {
                                        me.ownerLists.push(users[j]);
                                    }
                                }
                            // }
                        }
                    });
            }
            if (this.listQuery.searchAccountPropertyType === 'agent' || (type == 'transferDep' && selectedId)) {
                // 个人盤
                let arry = [];
                if(this.departmentRoles != 0 && this.listQuery.searchAccountPropertyType === 'agent'){
                    arry = this.departmentRoles.split(',');
                }
                this.axios
                    .post(this.pub.getApi().SearchAgentUser, {
                        departmentID: type == 'transferDep' ? selectedId :parseInt(arry[0])
                    })
                    .then(res => {
                        if (res.data.code === 0 && res.data.result) {
                            if(this.listQuery.searchAccountPropertyType === 'agent'){
                                if(this.departmentRoles !== 0){
                                    this.listQuery.departmentID = parseInt(arry[0]);
                                }
                            }else{
                                // 全选
                                if(this.departmentRolesAll.includes('0,0') == true){
                                    this.listQuery.departmentIDList  = []
                                }else if(this.departmentRolesAll.length > 1){
                                    this.listQuery.departmentIDList =[]
                                    this.listQuery.departmentIDList = this.departmentRolesAll
                                    .filter(item => item !== '0,0')
                                    .map(item => parseInt(item.split(',')[0]));
                                }else if(this.departmentRolesAll.length == 1 ){
                                    // this.listQuery.departmentIDList =  parseInt(this.departmentRolesAll[0])
                                    this.listQuery.departmentIDList =[]
                                    this.listQuery.departmentIDList.push(parseInt(this.departmentRolesAll[0]))

                                }
                            }

                            if(type != 'transferDep'){
                                this.getList();
                            }
                            let me = this;
                            let users = res.data.result;
                            me.agentLists = [];
                            if(arry && arry[0]){
                                for (let i in me.departmentOptions) {
                                    if (me.departmentOptions[i].accountDepartmentID === parseInt(arry[0])) {
                                        me.dePartmentNm = me.departmentOptions[i].departmentName;
                                    }
                                }
                                me.userOptions = [];
                            }
                            if(this.listQuery.searchAccountPropertyType === 'agent'){
                                for (let j in users) {
                                        if (users[j].accountID !== me.accountID && users[j].status === 'Normal') {
                                            me.userOptions.push(users[j]);
                                        }
                                    }
                            }
                            if(type == 'transferDep' && selectedId){
                                // if(this.isShowAgentRadio ){
                                //     for (var j in users) {
                                //         if (users[j].accountID !== me.accountID && users[j].status === 'Normal') {
                                //             me.agentLists.push(users[j]);
                                //             me.userOptions.push(users[j]);
                                //         }
                                //     }
                                // }else{
                                    for (let j in users) {
                                        if (users[j].status === 'Normal') {
                                            me.agentLists.push(users[j]);
                                        }
                                    }
                                // }
                            }
                        }
                    });
            }
        },
        // 組別下拉（樓盤轉移）
        getOrganizationOptions() {
            this.axios
                .get(this.pub.getApi().GetDepartmentsTreeByParentID, {
                    params: {
                        departmentID: this.userInfo.departmentID
                    }
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.organizationOptions.push(res.data.result);
                    }
                });
        },
        // 組別下拉改變
        newDepartmentChange(val) {
            const cascaderNodes = this.$refs.cascader.getCheckedNodes();
            if (cascaderNodes[0].children.length === 0) {
                this.$refs.cascader.dropDownVisible = false;
            }
            this.newDepartment = val;
            this.getDepartmentName(val, this.organizationOptions);
        },
        getDepartmentName(val, organizationOptions) {
            for (let i = 0; i < organizationOptions.length; i++) {
                if (val === organizationOptions[i].departmentID) {
                    this.mobilizationQuery.newDepartmentName = organizationOptions[i].departmentName;
                } else if (organizationOptions[i].childNode && organizationOptions[i].childNode.length > 0) {
                    this.getDepartmentName(val, organizationOptions[i].childNode);
                }
            }
        },
        // 角色下拉（人員調動）
        getUserRoles() {
            this.axios.get(this.pub.getApi().SerachChildRoleInfoByParentRoleID + `?parentRoleID=${this.userInfo.roleID}`).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    this.roleOptions = res.data.result;
                    // 过滤同级
                    // 验收要求不过滤同级
                    //var me = this;
                    //for (let index = 0; index < me.roleOptions.length; index++) {
                    //    if (me.roleOptions[index].roleID === me.userInfo.roleID) me.roleOptions.splice(index, 1);
                    //}
                }
            });
        },
        // 組別+角色下拉（人員調動）
        getUserInfoByAccountID() {
            this.axios
                .get(this.pub.getApi().GetUserInfoByAccountID, {
                    params: {
                        accountID: this.accountID
                    }
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.oldDepartments = res.data.result.roleList;
                    }
                });
        },
        handleScrollTop() {
            if (this.$refs.topScroll) {
                let scrollLeft = this.$refs.topScroll.scrollLeft
                this.$refs.multipleTable.bodyWrapper.scrollTo(scrollLeft, 0);
            }
        },
        // 查詢
        getList() {
            // 勾选全选后，页面需要展示位全部选中
            this.listQuery.accountID = this.accountID;
            const data = this.getSearchValue()
            // 当前若为不可转移楼盘组别 直接赋空值
            // if(!this.isdepID){
            //     this.list = []
            //     this.total= 0
            //     return
            // }
            this.listLoading = true;
            // this.axios.post(this.pub.getApi().SearchPropertyList, this.listQuery).then(res => {
            this.axios.post(this.pub.getApi().SearchPropertyList, data).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    this.list = res.data.result.data;
                    this.total = res.data.result.count;
                    this.listLoading = false;
                    setTimeout(() => {
                        if (this.$refs.multipleTable) {
                            this.tablewidth.width = this.$refs.multipleTable.bodyWrapper.scrollWidth + 'px'
                            this.$refs.multipleTable.doLayout()

                            //此代码为监听表格滚动条的事件：
                            this.tableDom = this.$refs.multipleTable.bodyWrapper
                            this.tableDom.addEventListener('scroll', () => {
                            // 滚动距离
                            let scrollLeft = this.tableDom.scrollLeft
                            this.$refs.topScroll.scrollTo(scrollLeft, 0);
                            })
                        }
                        if(this.showselected){
                            this.list.forEach((row) => {
                            if (this.showisDisProperty(row)) {
                                this.$refs.multipleTable.toggleRowSelection(row, true);
                                }
                            });
                        }
                    }, 500)
                }else{
                    this.listLoading = false;
                    if(res.data.code === 400 ){
                        this.error('搜索數據不正確')
                    }else{
                        this.error(res.data.message)
                    }
                }
            });
        },
        // handleChanges(val) {
        //     this.listQuery.departmentID = this.transferQuery.departmentID;
        //     this.getList();
        // },
        selectChange(val) {
            this.departmentRole = val;
            let arry = [];
            if(val){
                arry = val.split(',');
            }else{
                return
            }
            this.mobilizationQuery.oldDepartmentID = parseInt(arry[0]);
            this.mobilizationQuery.oldDepartmentName = arry[1];
            this.mobilizationQuery.oldRoleID = parseInt(arry[2]);
            this.mobilizationQuery.oldRoleName = arry[3];
            // this.department = false;
            // this.role = false;
            // this.checkJurisdiction(parseInt(arry[0]), parseInt(arry[2]), this.organizationOptions);
            // if (this.department === false || this.role === false) {
            //     console.log("---3----")

            //     if (document.getElementsByClassName('el-message').length === 0) {
            //         this.$message({
            //             type: 'error',
            //             message: '該組別和角色級別較高，無權操作，請重新選擇！',
            //             showClose: true
            //         });
            //     }
            //     return false;
            // }
        },
        getBack() {
            this.$router.push({ path: '/staffing/index' });
        },
        // 角色下拉改變
        newRoleChange(val) {
            this.newRole = val;
            let arry = [];
            if(val){
                arry = val.split(',');
            }
            let arry1 = [];
            if(this.departmentRole){
                arry1 = this.departmentRole.split(',');
            }
            this.mobilizationQuery.newRoleID = parseInt(arry[0]);
            if(this.mobilizationQuery.newRoleID == 4){
                this.mobilizationQuery.email = ''
            }
            this.mobilizationQuery.newRoleName = arry[1];
            for (let i = 0; i < this.oldDepartments.length; i++) {
                // 若新舊組別相同 則組別角色不能相同
                if (this.mobilizationQuery.newDepartmentID === parseInt(arry1[0])) {
                    if (this.mobilizationQuery.newDepartmentID === this.oldDepartments[i].accountDepartmentID && this.mobilizationQuery.newRoleID === this.oldDepartments[i].roleID) {
                        if (document.getElementsByClassName('el-message').length === 0) {
                            this.$message({
                                type: 'warning',
                                message: '組別角色重複，請重新選擇！',
                                showClose: true
                            });
                        }
                        return false;
                    }
                } else {
                    if (this.mobilizationQuery.newDepartmentID === this.oldDepartments[i].accountDepartmentID) {
                        if (document.getElementsByClassName('el-message').length === 0) {
                            this.$message({
                                type: 'warning',
                                message: '員工在該組別內已擁有角色，請重新選擇！',
                                showClose: true
                            });
                        }
                        return false;
                    }
                }
            }
        },
        // 員工下拉改變
        handleChange(val) {
            let arry = [];
            if(val){
                arry = val.split(',');
            }
            this.transferQuery.newAccountID = parseInt(arry[0]);
        },
        // 樓盤轉移
        propertyTransfer() {
            return new Promise((resolve, reject) => {
                // if (this.departmentRoles === '') {
                if ((!this.departmentRolesAll.length && this.listQuery.searchAccountPropertyType === 'owner')||(this.departmentRoles === '' && this.listQuery.searchAccountPropertyType === 'agent')) {
                    if (document.getElementsByClassName('el-message').length === 0) {
                        this.$message({
                            type: 'warning',
                            message: ' 請選擇組別及角色！',
                            showClose: true
                        });
                    }
                    return false;
                }else if(!this.listQuery.searchAccountPropertyType){
                    if (document.getElementsByClassName('el-message').length === 0) {
                        this.$message({
                            type: 'warning',
                            message: ' 請選擇放盤人類型！',
                            showClose: true
                        });
                    }
                    return false;
                }
                    let arry = [];
                    if(this.departmentRoles){
                        arry = this.departmentRoles.split(',');
                    }
                    // 判斷組別權限
                    // this.department = false;
                    // this.role = false;
                    // this.checkJurisdiction(parseInt(arry[0]), parseInt(arry[1]), this.organizationOptions);
                    // if (this.department === false || this.role === false) {
                    //     console.log("---4----")
                    //     if (document.getElementsByClassName('el-message').length === 0) {
                    //         this.$message({
                    //             type: 'error',
                    //             message: '該組別和角色級別較高，無權操作，請重新選擇！',
                    //             showClose: true
                    //         });
                    //     }
                    //     return false;
                    // } else
                    if (this.multipleSelection.length === 0) {
                        if (document.getElementsByClassName('el-message').length === 0) {
                            this.$message({
                                type: 'warning',
                                message: '請至少選擇一個樓盤去轉移',
                                showClose: true
                            });
                        }
                        return false;
                    } else if (this.transferQuery.newAccountID === null) {
                        if (document.getElementsByClassName('el-message').length === 0) {
                            this.$message({
                                type: 'warning',
                                message: '請選擇接收樓盤的員工！',
                                showClose: true
                            });
                        }
                        return false;
                    }
                        // 判斷樓盤類型
                        if (this.listQuery.searchAccountPropertyType === 'agent') {
                            this.transferQuery.departmentID = parseInt(arry[0]);
                            this.axios.post(this.pub.getApi().UpdatePropertyAgent, this.transferQuery).then(res => {
                                if (res.data.code === 0 && res.data.result) {
                                    if (document.getElementsByClassName('el-message').length === 0) {
                                        this.$message({
                                            type: 'success',
                                            message: '操作成功!',
                                            showClose: true
                                        });
                                    }
                                    this.getList();
                                    this.newInformation = ''
                                    this.transferQuery.departmentID = null
                                    this.resetNumber()
                                } else if (res.data.code == 1200) {
                                    if (document.getElementsByClassName('el-message').length === 0) {
                                        this.$message({
                                            type: 'error',
                                            message: '選擇項中包含現已不存在的房源，請重新選擇！',
                                            showClose: true
                                        });
                                    }
                                }
                                resolve()
                            });
                        }else if (this.listQuery.searchAccountPropertyType === 'owner') {
                            // 选择代理人不变时  调用老版本的仅更改放盘人接口
                            this.transferQuery.departmentID = parseInt(this.departmentRolesAll[0]);
                            this.axios
                                .post(this.pub.getApi().UpdatePropertyOwner, {
                                    propertyIDs: this.transferQuery.propertyIDs,
                                    accountID: this.transferQuery.newAccountID,
                                    departmentID: this.transferQuery.departmentID
                                })
                                .then(res => {
                                    this.isShowAgentRadio = false
                                    if (res.data.code === 0 && res.data.result) {
                                        if (document.getElementsByClassName('el-message').length === 0) {
                                            this.$message({
                                                type: 'success',
                                                message: '操作成功!',
                                                showClose: true
                                            });
                                        }
                                        if(!this.showselected){
                                            this.changeAgent = false
                                            this.getList();
                                            this.resetNumber()
                                        }
                                        resolve()

                                    } else if (res.data.code == 1200) {
                                        this.changeAgent = false
                                        if (document.getElementsByClassName('el-message').length === 0) {
                                            this.$message({
                                                type: 'error',
                                                message: '選擇項中包含現已不存在的房源，請重新選擇！',
                                                showClose: true
                                            });
                                        }
                                        reject('操作失败')
                                    }
                                });
                        }


            })

        },
        checkRolediction(departmentID,roleID){
            // rolePro：true 表可看可操作
            // 选中用户与登录用户为同一人，有操作权限
            /***
             * 选中用户与登录用户同组别
             * 登录用户若为总行1，roleOptions为[1,2，3，4]，若为分行，[2,3,4]
             * 当选中用户为其上级角色，rolePro不会置为true
             * eg.登录为分行2，[2,3,4],那么选中的用户为总行1，其不在roleOptions内
             */
            // 选中用户与登录用户不同组别，可看可操作
                if (this.userInfo.accountID === this.userDetail.accountID) {
                    this.rolePro = true;
                } else if(departmentID == this.userInfo.departmentID){
                    for (let j = 0; j < this.roleOptions.length; j++) {
                        if (roleID === this.roleOptions[j].roleID) {
                            this.rolePro = true;
                        }
                    }
                }else if(departmentID != this.userInfo.departmentID){
                    this.rolePro = true;
                }
        },
        // 检查权限
        checkJurisdiction(departmentID, roleID, organizationOptions) {
            if (this.userInfo.accountID === this.userDetail.accountID) {
                this.department = true;
                this.role = true;
            } else {
                for (let i = 0; i < organizationOptions.length; i++) {
                    if (departmentID === organizationOptions[i].departmentID) {
                        this.department = true;
                    } else if (organizationOptions[i].childNode && organizationOptions[i].childNode.length > 0) {
                        this.checkJurisdiction(departmentID, roleID, organizationOptions[i].childNode);
                    }
                }
                for (let j = 0; j < this.roleOptions.length; j++) {
                    if (roleID === this.roleOptions[j].roleID) {
                        this.role = true;
                    }
                }
            }
        },
        // table選擇
        sortChange(val) {
            this.transferQuery.propertyIDs = [];
            this.multipleSelection = val;
            // 当前页面存在选中长度变少后，页面显示“是否全部选中”
            if(val.length != this.listQuery.pageCount && this.total != val.length){
                this.showselected = false
            }else if(val.length == this.listQuery.pageCount  && this.selLength == this.total){
                this.showselected = true
            }else if(val.length != this.listQuery.pageCount && this.total == val.length){
                this.showselected = true
            }
            for (let i = 0; i < val.length; i++) {
                this.transferQuery.propertyIDs.push(val[i].propertyID);
            }
            // showOwnerErr：true 展示红字  筛选出一定会展示红字的可能
            // 当选中所有组别，此时要根据用户选中的楼盘数据，来判断其是否存在转移权限
            // 1.选中的所有楼盘的放盘人与当前登录用户是否为同一个人，同一个人则不展示红字
            // 2.不为同一个人的前提下
            /**
             * 选中的所有楼盘在同组别的情况下，根据所有楼盘的放盘人角色与当前登录用户角色进行比较，若存在比登录用户高的，可终止循环，展示红字
             * 不同组别的员工一定不展示红字（上方判断即可以排除该种）
             * */
            if(this.departmentRolesAll.includes('0,0') == true && this.listQuery.searchAccountPropertyType =='owner'){
                this.showOwnerErr = false
                if(val && val.length){
                    let hasDisData = val.every(item => {
                        return  item.accountID === this.userInfo.accountID
                    });
                    if(!hasDisData){
                        let idSet = new Set(this.roleOptions.map(item => item.roleID));
                        for (let item of val) {
                            // 所有选中楼盘的roleid 若不在接口返回允许更改得roleid中则展示红字，跳出循环
                            if (item.departmentID == this.userInfo.departmentID && !idSet.has(item.accountDepartmentRoleID)) {
                                this.showOwnerErr = true;
                                break;
                            }
                        }
                        // for (let i = 0; i < val.length; i++) {
                        //     if(val[i].departmentID == this.userInfo.departmentID){
                        //         // 利嘉阁的超级管理员与总行管理员为同级，roleid为5
                        //         if(val[i].accountDepartmentRoleID == this.userInfo.roleID || parseInt(val[i].accountDepartmentRoleID) < parseInt(this.userInfo.roleID) || (parseInt(val[i].accountDepartmentRoleID) == 5 && parseInt(this.userInfo.roleID)!=1&&parseInt(val[i].accountDepartmentRoleID)>parseInt(this.userInfo.roleID)) ){
                        //             this.showOwnerErr = true
                        //             break;
                        //         }
                        //     }
                        // }
                    }else{
                        this.showOwnerErr = false
                    }
                }
            }
            // this.checkRolediction(roleID);
        },
        // 人員調動
        staffTransfer() {
            let arry1 = [];
            if(this.departmentRole){
                arry1 = this.departmentRole.split(',');
            }
            if (this.mobilizationQuery.oldDepartmentID === null || this.mobilizationQuery.oldRoleID === null || this.newDepartment === '' || this.newRole === '') {
                this.repeatEmail = false
                if (document.getElementsByClassName('el-message').length === 0) {
                    this.$message({
                        type: 'warning',
                        message: '請選擇轉移的組別和角色',
                        showClose: true
                    });
                }
                return false;
            }
            for (let i = 0; i < this.oldDepartments.length; i++) {
                if (this.mobilizationQuery.newDepartmentID === parseInt(arry1[0])) {
                    if (this.mobilizationQuery.newDepartmentID === this.oldDepartments[i].accountDepartmentID && this.mobilizationQuery.newRoleID === this.oldDepartments[i].roleID) {
                        this.repeatEmail = false
                        if (document.getElementsByClassName('el-message').length === 0) {
                            this.$message({
                                type: 'warning',
                                message: '員工已擁有該組別角色，請重新選擇！',
                                showClose: true
                            });
                        }
                        return false;
                    }
                } else {
                    if (this.mobilizationQuery.newDepartmentID === this.oldDepartments[i].accountDepartmentID) {
                        this.repeatEmail = false
                        if (document.getElementsByClassName('el-message').length === 0) {
                            this.$message({
                                type: 'warning',
                                message: '員工在該組別內已擁有角色，請重新選擇！',
                                showClose: true
                            });
                        }
                        return false;
                    }
                }
            }
            this.department = false;
            this.role = false;
            this.checkJurisdiction(parseInt(this.mobilizationQuery.oldDepartmentID), parseInt(this.mobilizationQuery.oldRoleID), this.organizationOptions);
            if (this.department === true && this.role === true) {
                this.$refs.staffForm.validate(valid => {
                    if(valid){
                        this.axios.post(this.pub.getApi().UserOrganizationalMobility, this.mobilizationQuery).then(res => {
                            if (res.data.code === 0 && res.data.result) {
                                this.repeatEmail = false
                                if (document.getElementsByClassName('el-message').length === 0) {
                                    this.$message({
                                        type: 'success',
                                        message: '操作成功!',
                                        showClose: true
                                    });
                                }
                                this.$router.push({ path: '/staffing/index' });
                            } else if(res.data.code === 1308){
                                if (document.getElementsByClassName('el-message').length === 0) {
                                    this.$nextTick(()=>{
                                        this.repeatEmail = true
                                    })
                                    this.$message({
                                        type: 'error',
                                        message: `${this.mobilizationQuery.email}該電郵地址已註冊，請使用其他電郵地址。`,
                                        showClose: true
                                    });
                                }
                                return false;
                            }else if (res.data.code === 2061) {
                                this.repeatEmail = false
                                if (document.getElementsByClassName('el-message').length === 0) {
                                    this.$message({
                                        type: 'error',
                                        message: '員工在原組別中擁有代理盤，請先將資源進行轉移!',
                                        showClose: true
                                    });
                                }
                                return false;
                            } else if (res.data.code === 2031) {
                                this.repeatEmail = false
                                if (document.getElementsByClassName('el-message').length === 0) {
                                    this.$message({
                                        type: 'error',
                                        message: '員工在原組別中擁有樓盤，請先將資源進行轉移!',
                                        showClose: true
                                    });
                                }
                                return false;
                            } else if (res.data.code === 2030) {
                                this.repeatEmail = false
                                if (document.getElementsByClassName('el-message').length === 0) {
                                    this.$message({
                                        type: 'error',
                                        message: '員工在原組別中擁有金幣，請先將資源進行轉移!',
                                        showClose: true
                                    });
                                }
                                return false;
                            } else if (res.data.code === 2037) {
                                this.repeatEmail = false
                                if (document.getElementsByClassName('el-message').length === 0) {
                                    this.$message({
                                        type: 'error',
                                        message: '員工在原組別中擁有鑽石，請先將資源進行轉移!',
                                        showClose: true
                                    });
                                }
                                return false;
                            } else if (res.data.code === 2043) {
                                this.repeatEmail = false
                                if (document.getElementsByClassName('el-message').length === 0) {
                                    this.$message({
                                        type: 'error',
                                        message: '只有一個總行管理員不可以被轉移!',
                                        showClose: true
                                    });
                                }
                                return false;
                            }
                        });
                    }
                })
            }
        }


            // else {
            //     if (document.getElementsByClassName('el-message').length === 0) {
            //         console.log("---5----")

            //         this.$message({
            //             type: 'error',
            //             message: '該組別和角色級別較高，無權操作，請重新選擇！',
            //             showClose: true
            //         });
            //     }
            //     return false;
            // }

    }
};
</script>
<style lang="less" scoped>
.tandialog{
    margin-top:25vh;
    /deep/.el-dialog{
        border-radius:10px;
    }
    /deep/ .el-dialog__header{
        display: none;
    }
    /deep/.el-dialog__body{
        border: 1px dashed #0062FF;
        background-color: #EDF5FF;
        border-radius:10px;
        padding-top: 20px;
        padding-bottom: 20px;

    }
    .ce{
        text-align: center;
    }
    p{
        display: inline-block;
        font-size: 18px;
        color:#0062FF;
    }
    i{
        display: inline-block;
        color:  #0062FF;
        font-size: 18px;
        margin-left:5px;
    }
}
.divbox{
    box-sizing:border-box;
}
.box_div{
    height: 0;
}
.fixed_box{
    height: 230px;
}
.fixed{
    position: fixed;
    z-index: 999;
    background-color: #f3f3f5;
    // transition-duration: 1s;
    top: 50px;
    left: 140px;
    /* margin-top: 10px; */
    padding-top: 20px;
    padding-left: 20px;
    width:100%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);

}
.transfer-container {
    .span_errtxt{
        position: absolute;
        color: #E50113;
        font-size: 14px;
        min-width: 252px;
        line-height: 19px;
        margin-left: 10px;
    }
    .bottom-right{
        text-align: right;
    }
    .depTran_box{
        background-color: #fff;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        /deep/.el-form-item__label{
            width: 181px !important;
        }
        .owner_tit{
            border: 1px solid black;
            border-radius: 10px;
            width: 345px;
            padding: 10px;
            margin-bottom: 35px;
            margin-left: 57px;
            dev{
                font-size: 14px;
                color: #444444;

            }
        }
        .depleft_box{
            margin-left: 24px;
            padding-bottom: 25px;
        }
        .agentTrans{
            margin-left:10px;
        }
        .owner_tips{
            margin-left: 23px;
            margin-bottom: 10px;
            font-size: 14px;
        }
        .agentTrans_more{
            margin-left:1px;
        }
        // .dep_cascader{
        // }
        /deep/.el-cascader{
            width:300px !important;
        }
        .transfer_dep{
            margin-left: 6px;
        }

        .fangpan_one{
            margin-left: 5px;
        }
        .agentRadio{
            margin-left:189px;
            margin-bottom:15px;
        }
        /deep/.el-row .el-input__inner{
            border: 1px solid #DBDBDB;
            color: #000000;
            background-color: #FAFAFB;
        }
        /deep/.el-form-item__label{
            color: #171725;
        }
        .btn_box{
            margin-left: 102px;
            margin-top: 10px;
            .pribut{
                background-color:#0064FF ;
                width: 90px;
            }
            .back{
                color: #FFFFFF;
                background-color: #BBBBBB;
                width: 90px;
            }
        }
    }
    .property-tags-cascader-none-li {
        display: none;
    }
    .property-tags-cascader-panelcheckbox.el-cascader-panel.is-bordered {
        border: none;
        .el-scrollbar__view.el-cascader-menu__list {
            padding: 0;
        }
    }
    .allbtn{
        background-color: #409EFF;
        margin-bottom: 10px;
    }
    .disBtn{
        background-color: #BBBBBB;
        pointer-events: none;
        border-color: #BBBBBB;
    }
    .more {
        background-color: #e1c999;
        border-color: #e1c999;
        color: #fff;
        margin-left:10px;
        margin-bottom: 10px;;
    }
    .more:active {
        background-color: #e6a23c;
        border-color: #e6a23c;
        color: #fff;
    }
    .w100{
        width:100px;
    }
    .w150{
        width:150px;
    }
    .w160{
        width:160px;
    }
    .w315{
        width:315px;
    }
    .mr4{
        margin-right: 4px;
    }
    span.time {
        font-size: 14px;
        color: #666;
    }
    .w90{
        width: 90px;
    }
    .input-model {
        box-sizing: border-box;
        display: inline-block;
        height: 38px;
        line-height: 38px;
        border-radius: 10px;
        padding: 0 8px;
        font-size: 14px;
        color: #333;
        .w90 {
            margin: 0;
        }
        .pm {
            margin: 0 6px;
        }
        /deep/ .el-input__inner {
            padding: 0 8px;
            line-height: 38px;
            height: 36px;
        }
    }
    .area-span {
        font-size: 14px;
        color: #666;
    }
    .w100,
    .w150,
    .w160,
    .w180,
    .w315 {
        margin-right: 15px;
        margin-bottom: 10px;
    }
    .red {
        color: red !important;
        font-style: normal;
        line-height: 42px;
    }
    .redstar_one{
        position: absolute;
        left: -30px;
        top: -7px;

    }
    .wid_230{
        width: 230px;
    }
    .custom-selected{
        position: absolute;
        top: 1px;
        left:15px;
        cursor: pointer;
    }
    font-family: PingFangSC-Regular, PingFang SC;
    /deep/.el-table th > .cell {
        font-size: 13px;
        font-weight: 400;
        color: rgba(68, 68, 68, 1);
    }
    /deep/.el-table td,
    .el-table th span {
        height: 44px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
        line-height: 22px;
    }
    /deep/.el-table__header-wrapper {
        border-radius: 10px;
        height: 38px;
        background-color: rgba(80, 181, 255, 0.15);
    }
    /deep/.el-row .el-input__inner {
        border-radius: 10px;
        border: none;
        color: #000000;
        &::placeholder {
            font-size: 14px;
            color: #666666;
        }
    }
    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #0062ff;
        border-color: #0062ff;
    }
    text-align: left;
    .w160 {
        width: 160px;
    }
    .el-button {
        border-radius: 10px;
    }
    /deep/.el-table__header-wrapper {
        border-radius: 10px;
    }
    .transfer-title {
        font-size: 24px;
        margin: 0 0 20px 0;
    }
    .dep_mar{
        margin-left: 20px;
        .el-select + span {
            margin-left: -5px;
        }
    }
    .el-select.w_400 {
        width: 400px;
        /deep/.el-select__tags{
            max-height: 62px;
            overflow-y: auto;
        }
    }
    .el-select.w_40001 {
        width: 400px;
        /deep/.el-input__inner{
            max-height: 40px;
        }
    }
    .el-select.w_300 {
        width: 300px;
    }
    .container {
        padding: 10px;
        background-color: white;
        border-radius: 10px;
        .img-cover {
            background-image: url(//static.house730.com/m/images/staff-default.png);
            background-size: 100% 100%;
            width: 50px;
            height: 50px;
            display: block;
        }
        .blu_txt{
            color: #0062ff;
            cursor: pointer;
        }
        /*顶部滚动条*/
        .top-scroll {
            overflow-x: auto;
            overflow-y: hidden;
            width :100%;
            .top-scroll-content {
                background-color: #fff;
                height: 2px;
            }
        }
    }
    .operation-container {
        margin: 15px 0;
    }
    .bottom-container {
        margin-top: 20px;
    }
    .red {
        color: #ed1d25;
    }
    /deep/ .el-table th {
        padding: 7px 0;
        border-top-left-radius: 10px;
    }
    .btn {
        text-align: right;
        .el-button {
            border: none;
        }
    }
    .back {
        border: none;
    }
    .lef_10{
        margin-left: 10px;
    }
}
</style>
